/**
 * @title utility1.js: Global sub-module
 * @description A collection of functions used
 * application wide. This module should contain
 * generic utility code. No module specifics.
 */
define(function() {
  let util = {
	POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
    /**
     * John Resig's micro-templating function
     * @param  {[string]} str  String ID of template
     * @param  {[object]} data Object representing dynamic values
     * @return {[string]}      HTML representation as
     * a string
     */
    tmpl: function(str, data) {
      let fn = !/\W/.test(str) ? this.tmpl(document.getElementById(str).innerHTML) : new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' + 'with(obj){p.push(\'' + str.replace(/[\r\t\n]/g, ' ').split('<&').join('\t').replace(/((^|&>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)&>/g, '\',$1,\'').split('\t').join('\');').split('&>').join('p.push(\'').split('\r').join('\\\'') + '\');}return p.join(\'\');');
      return data ? fn(data) : fn;
    },
    /**
     * http://kenwheeler.github.io/slick/
     * Generalized intialization of carousel.
     * [carousel description]
     * @param  {[string]} id        [description]
     * @param  {[object]} options   [description]
     * @param  {[object]} settings  [description]
     * @return {[void]}             [description]
     */
    carousel: function(id, options, settings) {
      options = options || {};
      $slider = $(id);
      if (settings && settings.initFn) {
        $slider.on('init', settings.initFn);
      }
      // Initialize the carousel. Waits for the application style sheet
      // to load before initializing to ensure we have the correct
      // CSS attributes attached to DOM elements
      if (window.stylesLoaded) {
        COSTCO.util.initCarousel($slider, options, settings);
      } else {
        document.addEventListener('styles-loaded', function initCarouselEvent() {
          this.util.initCarousel(this.slider, options, settings);
        }.bind({
          util: COSTCO.util,
          slider: $slider,
        }), false);
      }
    },

    /**
     * Initializes the carousel and does any additional bindings and/or
     * settings.
     * @param  {[type]} $slider  [description]
     * @param  {[type]} options  [description]
     * @param  {[type]} settings [description]
     * @return {void}
     */
    initCarousel: function($slider, options, settings) {
      $slider.slick(options);
      if (settings && settings.hasPause) { // append a pause button
        $slider.find('.slick-dots').append('<li class="pause"><button class="playToggle" role="button" type="button" aria-label="' + messages.PAUSE + '"></button></li>');
        $slider.find('.pause button').unbind().on('click', function() {
          // define slider to pause/play as the closest parent of the play/pause button
          // cannot use $slider as by the time the page is initialized $slider points to a different carousel
          let mySlider = $(this).closest('.slick-slider');
          $(this).toggleClass('active');
          if ($(this).hasClass('active')) {
            mySlider.slick('slickPause');
            $(this).attr('aria-label', messages.PLAY);
          } else {
            mySlider.slick('slickPlay');
            $(this).attr('aria-label', messages.PAUSE);
          }
        });
      }

      if (options && options.arrows) {
        // Update the aria label on the arrows
        $slider.find('.slick-next').attr('aria-label', (settings != undefined && settings.nextLabel != undefined) ? settings.nextLabel : messages.NEXT_SLIDE);
        $slider.find('.slick-prev').attr('aria-label', (settings != undefined && settings.prevLabel != undefined) ? settings.prevLabel : messages.PREV_SLIDE);
      }

      // put descriptive text for carousel dot buttons for ADA
      $slider.each(function() {
        $(this).find('li button[data-role=none]').each(function(index) {
          $(this).text('slide set ' + (index + 1));
        });
        $(this).find('li').removeAttr('aria-hidden');
      });


      // Are there any events beforeChange/afterChange we are binding?
      if (settings && settings.beforeFn) {
        $slider.on('beforeChange', settings.beforeFn);
      }
      if (settings && settings.afterFn) {
        $slider.on('afterChange', settings.afterFn);
      }
      if (settings && settings.destroyFn) {
        $slider.on('destroy', settings.destroyFn);
      }
    },
    setStyleRule: function(selector, rule) {
      let stylesheet = document.styleSheets[(document.styleSheets.length - 1)];
      COSTCO.util.safe ( function() { 
    	  for (let i in document.styleSheets) {
    		  if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('rwd') >= 0) {
    			  stylesheet = document.styleSheets[i];
    			  break;
    		  }
    	  }
      })();
      if (stylesheet.addRule) {
        stylesheet.addRule(selector, rule);
      } else if (stylesheet.insertRule) {
        stylesheet.insertRule(selector + ' { ' + rule + ' }', stylesheet.cssRules.length);
      }
    },
    /**
     * Function decorator that wraps a provided function in a try/catch
     * to mitigate breaking JS execution. Returns a new function which
     * must be called.
     * @param {[function]} fn
     * @param {[string]} signature
     * @return {[function]}
     */
    safe: function(fn, signature) {
      return function util_safe() {
        try {
          fn.apply(this, arguments);
        } catch (e) {
          console.error(e, 'at ' + signature);
        }
      };
    },
    /**
     * Function used to call bing to obtain location data based on query value
     *
     * Param
     * 	  postalCode -> postalCode that we want to get the city or state for
     * 	  sucessCallback -> function to be fired after the sucess of the ajax request
     *
     */
    callBing: function(postalCode, successCallback, errorCallback) {

    	var globalBingStaticKeyVar = $('#globalBingStaticKey').val();	
        let geocodeRequest = 'https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + postalCode + '&includeNeighborhood=true&include=ciso2&maxResults=5&key=' + globalBingStaticKeyVar;
    	
    	$.ajax({
        url: geocodeRequest,
        dataType: 'jsonp',
        jsonp: 'jsonp',
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          console.log('error getting City / State' + postalCode);
          if (errorCallback) errorCallback(XMLHttpRequest, textStatus, errorThrown)
        },
        success: function(data, textstatus, XMLHttpRequest) {
          console.log('BING - Success retrieving location');
          successCallback(data, textstatus, XMLHttpRequest);
        },
      });
    },

    /**
     * Calls the GeocodeAPI to obtain location data based on the provided postal code.
     *
     * @param {string} postalCode - The postal for which to get city/state data.
     * @param {function} successCallback - The function to be called on successful AJAX request.
     * @param {function} errorCallback - The function to be called if the AJAX request fails.
     */
    callGeocodeAPI: function(postalCode, successCallback, errorCallback) {
      let country = 'USA'; 
      if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
        country = 'CAN';
        postalCode = postalCode.toUpperCase();
      }

      const geocodeRequestUrl = $('#geocodeServiceEndpoint').val() + '?q=' + postalCode + '&country=' + country;

      const deriveCityStateFromZipCodeEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED
          && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === 'true';
      const allowedCityTypes = deriveCityStateFromZipCodeEnabled ? ['A', 'D'] : ['D'];

      errorCallback = errorCallback || successCallback;
      const handleError = () => {
        console.log('Error getting City/State for ' + postalCode);
        let errData = [{invalidZip: true}];
        errorCallback(errData);
      };

      $.ajax({
        url: geocodeRequestUrl,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown) {
          if (textStatus === 'error') {
            handleError();
          }
        },
        success: function(data, textStatus, jqXHR) {
          let filteredElements = (data && data.length > 0)
              ? data.filter(element => allowedCityTypes.includes(element.cityType))
              : [];
          if (filteredElements.length) {
            console.log('GeocodeAPI - Success retrieving location');
            successCallback(filteredElements, textStatus, jqXHR);
          } else {
            handleError();
          }
        },
      });
    },

    /**
     * BD only: calls Bing Location service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
     * @param {string} zipCode
     * @returns {object} Deferred
     */
    callBingAndUpdateBDLocationCookie: function(zipCode) {
      let deferred = $.Deferred();
      let updateCookie = function(data) {
        if (data && data.resourceSets && data.resourceSets[0] && data.resourceSets[0].estimatedTotal > 0) {
          let city = '' + data.resourceSets[0].resources[0].address.locality;
          let state = '' + data.resourceSets[0].resources[0].address.adminDistrict;
          let countryCode = '' + data.resourceSets[0].resources[0].address.countryRegionIso2;
          let locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
          let expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
          deferred.resolve(data);
        } else {
          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
          console.log('BING - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
          deferred.resolve(data);
        }
      }
      COSTCO.util.callBing(zipCode, updateCookie);
      return deferred.promise();
    },
    /**
     * BD only: calls Geocode API service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
     * @param {string} zipCode
     * @returns {object} Deferred
     */
    callGeocodeApiAndUpdateBDLocationCookie: function(zipCode) {
      let deferred = $.Deferred();
      let updateCookie = function(data) {
    	  let totalResponses = data.length;
        if (totalResponses != 0) {
          let city = '' + data[0].city;
          let state = '' + data[0].stateProvinceAbbreviation;
          let countryCode = '' + data[0].country === "USA" ? "US" : "CA";
          let locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
          let expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
          COSTCO.util.setInSession("finalZipcode", data[0].postalCode);
          deferred.resolve(data);
        } else {
          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
          console.log('Geocode API - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
          deferred.resolve(data);
        }
      }
      COSTCO.util.callGeocodeAPI(zipCode, updateCookie);
      return deferred.promise();
    },
    /**
     * Calls bing and updates zip/state/city cookies
     * @retrns jquery Deferred object
     */
    callBingAndUpdateCookies: function(zipcode) {

      let deferred = $.Deferred();

      let updateCookieValues = function(data) {
        let totalResponses = data.resourceSets[0].estimatedTotal;
        if (totalResponses != 0) {
        	let province = null;
            let country = null;
            let city = data.resourceSets[0].resources[0].address.locality;
            try {
                //Check out if country is Puerto Rico specific
                country = data.resourceSets[0].resources[0].address.countryRegionIso2;
                if (country != undefined && country === 'PR') {
                  province = data.resourceSets[0].resources[0].address.countryRegionIso2;
                  country = 'US';
                } else {
                  province = data.resourceSets[0].resources[0].address.adminDistrict;
                }
              } catch (e) {
                province = "";
              }
        	$.cookie("invCheckPostalCode", zipcode);
        	$.cookie("invCheckStateCode", province);
        	$.cookie("invCheckCity", city);
        	deferred.resolve(data);
        } else {
          deferred.reject();
        }
      }

      COSTCO.util.callBing(zipcode, updateCookieValues);

      return deferred.promise();
    },
    /**
     * Calls GeocodeAPI and updates zip/state/city cookies
     * @retrns jquery Deferred object
     */
    callGeocodeAPIAndUpdateCookies: function(zipcode) {

        let deferred = $.Deferred();

        let updateCookieValues = function(data) {
        	let province = null;
        	let country = null;
        	let city = null;
        	let totalResponses = data.length;
        	if (totalResponses != 0) {
	        	try {
	        	  city = data[0].city;
	        	  province = data[0].stateProvinceAbbreviation;
	        	  if (province == null) {
	        		  province = data[0].stateProvince;
	        	  }
	        	  country = data[0].country;
	        	} catch (e) {
	        		console.error('Error: '+ e.message);
	            }
	        	
	        	//SFSTRY0035043 don't update header zip on multishipping page
	        	if(typeof checkoutPage == 'undefined' || checkoutPage !== 'multi-shipping'){
	        		$.cookie("invCheckPostalCode", zipcode);
		        	$.cookie("invCheckStateCode", province);
		        	$.cookie("invCheckCity", city);
	        	}
	        	
	        	deferred.resolve(data);
        	} else {
        		deferred.reject();
        	}
        }

        COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);

        return deferred.promise();
    },

    hover_click_popover: function(selector, content, trigger, placement) {
      let hoverClickElement = $(selector);
      hoverClickElement.attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      });
      hoverClickElement.popover({
          html: true,
          sanitize: false,
          animation: false,
          delay: {
            show: 400,
            hide: 400,
          },
          content: function() {
            return $(content).html();
          },
          container: selector,
          placement: placement || 'bottom',
          trigger: trigger || 'hover click',
        })
        .on('keydown', function(e) {
          if (e.which == 13) {
            if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
              e.preventDefault();
              $(this).popover('show');
            }
          }
        })
        .on('mouseleave focusout', '.popover', {
          selector: selector,
          content: content,
          placement: placement || 'bottom',
        }, this.popoverLeave)
        // Adding listener to toggle the aria tags when popover shown/hidden
        .on('shown.bs.popover', function() {
          if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) &&
            $.cookie('WC_BD_ZIP') != null) {
            $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
          }
          $(this).attr('aria-expanded', 'true');

          // used to create ada required attributes on popover
          let identifierSrting = $(selector)[0].id;
          $(this).find('.popover-content').attr('id', identifierSrting + '-id');
          // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
          // is not populated when no tabindex is specified this caused all a and input
          // to not function on click event
          $(this).find('.popover-content').attr('tabindex', '-1');
          // New requirement to focus on the first visible input on popover shown
          let firstInput = $(this).find('a,input[type!=hidden]')[0];
          $(this).removeAttr('aria-describedby');
          $(this).find('.popover-content').removeAttr('aria-label');
          $(this).find('.popover').removeAttr('role');
          if (firstInput)
            $(firstInput).focus();
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        })
        // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
        // solution to trigger the focus on text boxes on mousedown event
        .on('mousedown', 'input[type=search], input[type=text]', function() {
          $(this).trigger('focus');
        });
    },
    click_popover: function(selector, content, trigger, placement) {
      let ClickElement = $(selector);
      ClickElement.attr({
        'aria-expanded': 'false',
      });
      ClickElement.popover({
          html: true,
          sanitize: false,
          animation: false,
          delay: {
            show: 400,
            hide: 400,
          },
          content: function() {
            return $(content).html();
          },
          container: selector,
          placement: placement || 'bottom',
          trigger: trigger || 'click',
        })
        .on('keydown', function(e) {
          if (e.which == 13) {
            if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
              e.preventDefault();
              $(this).popover('show');
            }
          }
        })
        .on('click focusout', '.popover', {
          selector: selector,
          content: content,
          placement: placement || 'bottom',
        }, this.clickpopoverLeave)
        // Adding listener to toggle the aria tags when popover shown/hidden
        .on('shown.bs.popover', function() {
          if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) &&
            $.cookie('WC_BD_ZIP') != null) {
            $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
          }
          $(this).attr('aria-expanded', 'true');
          
          if (content === '#ca-grocery-delivery-postal-code-popover') {
            $(this).find('#postal-code-input').val($('.user-entered-zip:first').text());
          }
          
          $('#delivery-postal-change,  #set-delivery-zipcode').removeAttr('aria-describedby');
          $('#delivery-postal-change,  #set-delivery-zipcode').find('.popover').removeAttr('role');

          // used to create ada required attributes on popover
          let identifierSrting = $(selector)[0].id;
          $(this).find('.popover-content').attr('id', identifierSrting + '-id');
          // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
          // is not populated when no tabindex is specified this caused all a and input
          // to not function on click event
          $(this).find('.popover-content').attr('tabindex', '-1');
          $(this).find('.popover-content').removeAttr('aria-label');
          // New requirement to focus on the first visible input on popover shown
          let firstInput = $(this).find('a,input[type!=hidden]')[0];
          if (firstInput)
            $(firstInput).focus();
          let firstBDInput = $(this).find('div > input[type!=hidden]')[0];
          setTimeout(function() {
            if (firstBDInput) {
              $(firstBDInput).focus();
            }
          }, 100);
            $('#postal-code-input-grocery').on( 'focusout', function() {
        		let content = $('#postal-code-input-grocery').val();
            	if(content !== undefined && content != '') {
            		$('#postal-code-input-grocery-label').addClass('active');
            	}
  			});
            let nameOfCategoryInput = $('#delivery-postal-code-popover-container').parent().parent().parent().attr('id');
            $('#delivery-postal-form').append('<input type="hidden" name="category-grocery-delivery" value="'+nameOfCategoryInput+'">')
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        })
        // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
        // solution to trigger the focus on text boxes on mousedown event
        .on('mousedown', 'input[type=search], input[type=text]', function() {
          $(this).trigger('focus');
        });
    },
    hover_click_popover_nav: function(selector, content, trigger) {
      let hoverClickElement = $(selector);
      hoverClickElement.attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      });
      hoverClickElement.popover({
          html: true,
          animation: false,
          delay: {
            show: 400,
            hide: 400,
          },
          content: function() {
            return $(content).html();
          },
          container: selector,
          placement: 'bottom',
          trigger: trigger || 'hover click',
        })
        .on('keydown', function(e) {
          if (e.which == 13) {
            if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
              e.preventDefault();
              $(this).popover('show');
            }
          }
        })
        .on('mouseleave focusout', '.popover', {
          selector: selector,
          content: content,
        }, this.popoverLeave)
        // Adding listener to toggle the aria tags when popover shown/hidden
        .on('shown.bs.popover', function() {
          $(this).attr('aria-expanded', 'true');
          $(this).find('.popover').addClass('top50pixels');
          $(this).find('.popover-content').attr('role', 'region');
          // used to create ada attributes on popover
          let identifierSrting = $(selector)[0].id;
          $(this).find('.popover-content').attr('id', identifierSrting + '_id');
          $(this).find('.popover-content').attr('aria-label', identifierSrting + '_label');
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        });
    },
    /*
     * Function used to handle closing the pop-over based on which element is receiving focus
     * If it is not a child element of the pop-over the pop-over will close
     */
    popoverLeave: function(event) {
      let eventType = event.type;
      let isInput = $(event.target).is('input');
      // relatedTarget of a focusout event is the element which is receiving focus.
      let relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget ||
        $.contains($(event.data.selector).get(0), event.relatedTarget);
      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
      // the second condition is to keep popover open if focus stays within the popover.
      if ((eventType == 'mouseleave' && !isInput) || (eventType == 'focusout' && event.target && !relatedTargetIsContained)) {
        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
          // If ZIP code is set by Akamai, force-submit on popover leave
          COSTCO.zipCodeModal.forceSubmitZipCode();
        } else {
          $(event.data.selector).popover('destroy');
          COSTCO.util.hover_click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
        }
      }
    },
    clickpopoverLeave: function(event) {
      event.stopPropagation();
      let eventType = event.type;
      let isInput = $(event.target).is('input');
      // relatedTarget of a focusout event is the element which is receiving focus.
      let relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget ||
        $.contains($(event.data.selector).get(0), event.relatedTarget);
      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
      // the second condition is to keep popover open if focus stays within the popover.
      if ((eventType == 'click' && !isInput && isInput.length === 0) || (eventType == 'focusout' && event.target && !relatedTargetIsContained)) {
        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
          // If ZIP code is set by Akamai, force-submit on popover leave
          COSTCO.zipCodeModal.forceSubmitZipCode();
        } else {
          setTimeout(function(){ 
            $(event.data.selector).popover('destroy');
            COSTCO.util.click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
          }, 100);
        }
      }
    },
    /*
     * Function used to get whether or not the element is within the last or first
     * link within the target level container
     *
     * If the need arise we can actually return the decimal position of the element
     * by looping through the array not exactly needed here
     *
     * If the element is the first function will return 0
     * If the element is the last function will return 1
     * If other -1
     */
    get_element_position: function(element, searchCriteria) {
      let containerDivLinkArr = $(searchCriteria);
      if (containerDivLinkArr.first()[0] == element)
        return 0;
      if (containerDivLinkArr.last()[0] == element)
        return 1;
      return -1;
    },
    /**
     * This function makes icons in social networks popover content tabbable for ADA purposes
     * @param {string} selector - the element which contains a social networks popover
     * @return {void}
     */
    socialNetworksPopover: function(selector) {
        let popoverElement = $('.' + selector);
        let popoverContent = $(".social-popover-container").html();
        popoverElement.attr({
          'data-content': popoverContent,
          'aria-haspopup': 'true',
          'aria-expanded': 'false',
          'tabindex': 0,
          'role': 'tooltip',
        });
        popoverElement.popover({sanitize: false})
          .on('keydown', function(event) {
            //Enter event keycode
            if (event.which === 13) {
              $(this).popover('toggle');
            //Esc event keycode
            } else if (event.which === 27) {
              $(this).popover('hide');
            //Shift+Tab event keycode
            } else if (event.shiftKey && event.keyCode === 9) {
              $(this).popover('hide');
            }
          })
          .on('focus', function() {
            $(this).popover('toggle');
            let tooltipElement = $(this);
            let lastIconArr = document.getElementsByClassName('last-icon');
            let popoverContentId = $(this).attr('aria-describedby');
            $.each(lastIconArr, function(index, value) {
            	if (popoverContentId !== undefined && $(lastIconArr[index]).length !== 0) {
	            	$(lastIconArr[index]).on('blur', function(){
	                tooltipElement.popover('hide');
	              });
	            }
            });
            let contentElements = $('body').find('.social-popover');
            contentElements.find('img').each(function(){
              $(this).on('keypress', function(){
                this.onclick();
              })
            })
          })
          .on('shown.bs.popover', function() {
            $(this).attr('aria-expanded', 'true');
          })
          .on('hidden.bs.popover', function() {
            $(this).attr('aria-expanded', 'false');
          });
        $(':not(.' + selector + ')').on('click', function(){
          $('.co-help').each(function(){
            if ($(this).attr('aria-expanded') === 'true') {
              $(this).popover('hide');
            }
          })
        })
      },
    
    /**
     * Function used to simply show/hide popover capability to add accesibility features
     * function popover parameters are expected to be defined in the element as normal bootsrap popover
     *  hover and focus been triggered using data-trigger functionality. 
     */
    swatch_accesible_popover: function(selector) {
      let popoverElement = $(selector);
      popoverElement.attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
        'tabindex': 0,
        'role': 'tooltip',
      });
      popoverElement.popover()
        .on('shown.bs.popover', function() {
          $(this).attr('aria-expanded', 'true');
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        });
    },
    signupFormValidation: function(element) {
      $(element).validate({
        rules: {
          emailSignUp: {
            required: true,
            email: true,
          },
        },
        messages: {
          emailSignUp: messages.ERR_INVALID_EMAIL,
        },
        errorPlacement: function(error, element) {
          let p = element.parent('div');
          error.addClass('emailSignUp');
          p.after(error);
        },
      });
      if ($(element).valid()) {
        util.emailSubmit(element);
      }
      return false;
    },
    getMemberCookie: function() {
      let isSignedIn,
        isMember = false,
        isValidated = false,
        isVerified = false,
        isActive = false,
        usage = '',
        membershipNumber = '';
      let m = $.cookie('wcMember'),
        h = $.cookie('hashedUserId'),
        p = $.cookie('rrDisabledPref'),
        r = $.cookie('rrStoreFlag');
      if ((h != null && h == '""') ||
        (h == null && p == null && r == null) ||
        (h == null && ((p != null && p == '""') || (r != null && r == '""')))) {
        isSignedIn = false;
      } else if ((h != null && h == '') ||
        (h == null && p == null && r == null) ||
        (h == null && ((p != null && p == '') || (r != null && r == '')))) {
        isSignedIn = false;
      } else if ((h != null & h != '""') ||
        (h == null && (p != null && p != '""') && (r != null && r != '""'))) {
        isSignedIn = true;
      } else {
        isSignedIn = 'undefined';
      }
      if (m != null && m != 'undefined') {
        let cArray = m.split(',');
        if (cArray.length > 1) {
          if (cArray[1] == '1') {
            isMember = true;
          }
          if (typeof cArray[3] !== 'undefined') {
            usage = cArray[3];
          }
          if (cArray[4] == '1') {
            isValidated = true;
          }
          if (cArray[5] == '1') {
            isVerified = true;
          }
          if (cArray[6] == 'E0002') {
            isActive = true;
          }
          if (typeof cArray[8] !== 'undefined') {
            membershipNumber = cArray[8];
          }
        }
      } else {
        isMember = 'undefined';
      }
      return {
        signedIn: isSignedIn,
        costcoMember: isMember,
        validated: isValidated,
        verified: isVerified,
        active: isActive,
        usage: usage,
        membershipNumber: membershipNumber,
      };
    },
    /**
     * This function checks if the user has signed in
     */
    isUserSignedIn: function() {
        return this.getMemberCookie().signedIn === "true";
    },
    checkSsoLogin: function(aTag){
    	aTag.href += (aTag.href.indexOf("?") < 0 ?  "?redirectLogin=" + COSTCO.util.isUserLoggedIn() : "&redirectLogin=" + COSTCO.util.isUserLoggedIn());	
    },
    disbleElementById: function(id){
    	$("#"+id).hide();	
    },
    checkAndDisableSignInButton: function(){
    	if(this.isUserLoggedIn())
    		this.disbleElementById("bd-specific-sign-in-button");
    },
    
    /**
     * This function checks if the user has valid membership
     */
    isCostcoMember: function() {
        return this.getMemberCookie().costcoMember  != 'undefined' ? userInfo.costcoMember : false;
    },
    /**
     * sets a cookie with given name, value, expiration and domain
     *
     * @param  {[string]} cookieName - The name of the cookie to set
     * @param  {[string]} cookieValue - The value for the cookie to set
     * @param  {[int]} cookieExpires - The number of days until the cookie expires
     * @parm   {[string]} cookieDomain - The domain of the cookie to set
     * @return {void}
     */
    setCookie: function(cookieName, cookieVal, cookieExpires, cookieDomain) {
      cookieExpires = parseInt(cookieExpires);
      if(typeof(cookieDomain) !=='undefined') {
      $.cookie(cookieName, cookieVal, {
        expires: cookieExpires,
        path: '/',
              domain: cookieDomain
      });
      } else {
          $.cookie(cookieName, cookieVal, {
              expires: cookieExpires,
              path: '/',
          });
        }
    },

    /**
     * Gets the language id of the users's session. default is -1(English)
     * for US and -24(English) for CA
     * @return {[int]} the langId
     */
    getLangId: function() {
      let selectedLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
      var host = window.location.host;
      var cookieDomain = wcs.domain;
      if (host.indexOf('bd-cmc.vqa') > -1 || host.indexOf('bd-cmc.vuat') > -1 || host.indexOf('bd-cmc.ecom') > -1) {
        cookieDomain = '.costco.com';
      }
      if (typeof(selectedLang) == 'undefined' || !selectedLang) {
        if(wcs.hasOwnProperty('langId')){
          COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, wcs.langId, cookies.SELECTED_LANG_EXPIRES, cookieDomain);
          return parseInt(wcs.langId);
        } else {
          // check for stgbrowse costco domains
          if (host.indexOf('stgbrowseca') > -1 || host.indexOf('stgbrowse-ca') > -1 || host.indexOf('ca-cmc') > -1 || host.indexOf('ca-stage') > -1) {
            return -24;
          }
          if (host.indexOf('.com') > -1) {
            return -1; // Default .com lang
          } else {
            COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, "-24", cookies.SELECTED_LANG_EXPIRES, cookieDomain);
            return -24; // Default .ca lang
          }
        }
      }
      else{
        // The selectedLanguage cookie exists and the selectedLanguageOld cookie does not exist. 
        this.registerLanguageListener();
      }
      return selectedLang;
    },
    /**
     * Get the warehouse number for the user's session - used mainly for image templates
     */
    getWarehouseNumber: function() {
      let langId = this.getLangId();
      if (langId < -1) {
        return 894;
      } else {
        return 847;
      }
    },
    /**
     * Gets the string value of the user's region. Default is null.
     * @return {[string]} the string value of SELECTED_REGION_COOKIE
     */
    getRegion: function() {
      let selectedRegion = $.cookie(cookies.SELECTED_REGION_COOKIE);
      if (typeof(selectedRegion) == 'undefined' || !selectedRegion) {
        selectedRegion = null;
      }
      return selectedRegion;
    },
    getScreenType: function() {
      let width = $(window).width();
      if (width >= 1025) return 'DESKTOP';
      if (width >= 769) return 'TABLET-LANDSCAPE';
      if (width >= 668) return 'TABLET-PORTRAIT';
      if (width >= 376) return 'PHONE-LANDSCAPE';
      return 'PHONE-PORTRAIT';
    },
    is_touch_device: function() {
      return 'ontouchstart' in window // works on most browsers
        ||
        navigator.maxTouchPoints; // works on IE10/11 and Surface
    },
    emailSubmit: function(form) {
        let locale = COSTCO.util.getLocale();
        let isWhatCountsEnabled = $("input[name='whatCountsEventsFeatureFlagFooter']").val();
        let isAdobeEnabled = $("input[name='adobePreferencesFeatureFlagFooter']").val();
        if (isAdobeEnabled == 'true')  {
      	  if (locale != 'en-US') {
      		  let url = form.action;
	          document.location.href = url;
    	  } else {
  	    	  let data = {
  	    			  memberNumber: '',
  	    			  emailAddress: $('#footer-email-offers').val().trim(),
  	    			  listSource:'Footer SignUp'
  	    	  }
  	  	  	  COSTCO.AdobeEvents.sendEmailSubscriptionEvent($("input[name='adobeSubscribeEndpointFooter']").val(), contextVariables, data);
    	      }
    	  }
    	  if (isWhatCountsEnabled == 'true' || isWhatCountsEnabled === '1') {
  	      if (locale != 'en-US') {
  	        let url = form.action;
  	        document.location.href = url;
  	      } else {
  	        $.ajax({
  	          type: 'POST',
  	          url: form.action,
  	          data: 'emailSignUp=' + form['emailSignUp'].value,
  	          success: function() {
  	            $(form).find('input[type=text]').each(function() {
  	              $(this).val('');
  	            });
  	          },
  	        });
  	      }
    	  }
    	 let successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
       $(form).after(successP);
       $(form).addClass('hide');
       return false;
      },
	
	emailSubscribeForm: function(element) {
      $.validator.addMethod('countryspecificpostalcodePassCountrySelectorModal', function(value, element) {
        return !(COSTCO.util.getLangId() == -1) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
      }, messages.ERR_ENTER_ZIPCODE);
      $.validator.addMethod('email', function(value, element) {
        return /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value.toLowerCase());
      }, messages.JS_VALID_EMAIL);
      $(element).validate({
        rules: {
          emailAddress: {
            required: true,
            email: true, 
          },
          deliveryZipCode: {
            required: true,
            countryspecificpostalcodePassCountrySelectorModal: true,
          },
        },
        messages: {
          emailAddress: messages.ERR_INVALID_EMAIL,
          deliveryZipCode: messages.ERR_ENTER_ZIPCODE,
        },
        errorPlacement: function(error, element) {
          if (element.attr('name') == 'emailAddress') {
            element.parent().addClass('error');
            error.insertAfter($('[name=emailAddress]'));
          } else if (element.attr('name') == 'deliveryZipCode') {
            element.parent().addClass('error');
            error.insertAfter($('[name=deliveryZipCode]'));
          } else {
            error.insertAfter(element);
          }
        },
      });
      if ($(element).valid()) {
        util.emailSubscribeSubmit(element);
      }
      return false;
    },
	
	emailSubscribeSubmit: function(form) {
      $.ajax({
        type: 'POST',
        url: form.action,
        data: 'emailAddress=' + form['emailAddress'].value + '&deliveryZipCode=' + form['deliveryZipCode'].value + '&newLocation=' + form['newLocation'].value,
        success: function() {
          $(form).find('input[type=text]').each(function() {
            $(this).val('');
          });
        },
      });
      let successP = '<p class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
      $(form).after(successP);
      $(form).addClass('hide');
      return false;
    },
	
	  emailTruckloadSubscribeForm: function(element) {
      let errorElement = null; // Variable to store the first error element
      $.validator.addMethod('email', function(value, element) {
          return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
      }, messages.ERR_INVALID_EMAIL);
      $.validator.addMethod('costcoMembership', function(value, element) {
          return this.optional(element) || /^\d{12,16}$/.test(value);
      }, messages.ERR_INVALID_MEMBERSHIP_NO_BD);
      $(element).validate({
          rules: {
              userName: { required: true },
              membershipNo: { required: true, costcoMembership: true },
              emailAddress: { required: true, email: true }
          },
          messages: {
              userName: messages.ERR_USERNAME_REQUIRED,
              membershipNo: { required: messages.ERR_MEMBERSHIP_NUMBER_REQUIRED, costcoMembership: messages.ERR_INVALID_MEMBERSHIP },
              emailAddress: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL }
          },
          errorPlacement: function errorPlacement(error, element) {
              if (!errorElement) { // Store the first error element
                  errorElement = element;
              } else if (element.attr('name') == 'userName') {
                  element.parent().addClass('error');
                  error.insertAfter($('[name=userName]'));
              } else if (element.attr('name') == 'membershipNo') {
                  element.parent().addClass('error');
                  error.insertAfter($('[name=membershipNo]'));
              } else if (element.attr('name') == 'emailAddress') {
                  element.parent().addClass('error');
                  error.insertAfter($('[name=emailAddress]'));
              } else {
                  error.insertAfter(element);
              }
          },           
      });
      if ($(element).valid()) {
          util.emailTruckloadSubscribeSubmit(element);
      }else {
        errorElement.focus();
             }
      return false;
  },
	 
	 emailTruckloadSubscribeSubmit: function(form) {
    	event.preventDefault();
    	$.ajax({
            type: 'POST',
            url: form.action,
            data: 'emailAddress=' + form['emailAddress'].value + '&userName=' + form['userName'].value + '&membershipNo=' + form['membershipNo'].value +
            '&BusinessName=' + form['BusinessName'].value + '&Address1=' + form['Address1'].value + '&Address2=' + form['Address2'].value+ '&City=' + form['City'].value +
            '&State=' + form['State'].value + '&zipcode=' + form['zipcode'].value + '&phonenumber=' + form['phonenumber'].value + '&items=' + form['items'].value,
            success: function() {
              $(form).find('input[type=text]').each(function() {
                $(this).val('');
              });
              $(form).find('input[type=email]').each(function() {
                  $(this).val('');
               });
            },
          });
          let successP = '<p id="successP" tabindex="0" class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + " " + messages.MSG_EMAIL_RECEIVED + '.</p>';
          $(form).before(successP);
          $(form).addClass('hide');
          document.getElementById('successP').focus();
          return false;
        },

    /**
     * This function appends an additional panel to an existing accordion using
     * the accordion_id. The header and body represent the HTML that will display
     * for this add on.
     * @param  {[string]} accordion_id - The accordion data structure's id
     * @param  {[string]} header - String (html) to display as the panel header
     * @param  {[string]} body - String (html) to display as the panel body
     * @return {[void]}
     */
    accordion_addon: function(accordion_id, header, body, handlers, parent) {
      let position = $('#' + accordion_id).children().length + 1;
      let handlerTemplate;
      if (typeof handlers == 'undefined') {
        handlerTemplate = '';
      } else {
        handlerTemplate = handlers;
      }
      $('#' + accordion_id).append(this.tmpl('tmpl_accordion_addon', {
        accordion_id: accordion_id,
        pos: position,
        header: header,
        body: body,
        handlers: handlerTemplate,
        parent: parent !== 'undefined' ? parent : true,
      }));
    },
    /**
     * Retrieve the value of the 'rememberedShowMemberItem' cookie
     * used to display member-only pricing without the need to sign in
     */
    getRememberedShowMemberItem: function(){
      let rememberMeCookie = $.cookie('rememberedShowMemberItem');
      let cookieExists = (rememberMeCookie === undefined|| rememberMeCookie === null)? false : true;
      return cookieExists;
    },
    /**
     * If the user is signed in and has a Costco membership number stored,
     * show the member-only prices else don't.
     * @return {[void]}
     */
    display_member_prices: function() {
      let member_cookie = this.getMemberCookie(),
        signed_in = member_cookie.signedIn || false,
        is_member = member_cookie.costcoMember || false,
        is_validated = member_cookie.validated || false,
        is_active = member_cookie.active || false,
        is_bd = util.isBusinessDelivery();
      let rememberMe = this.getRememberedShowMemberItem();
      // This check is added to keep BD flow unaffected by the change in BC flow
      let display_moi_price = COSTCO.util.isBusinessDelivery() ? signed_in && is_member : signed_in && is_member && is_validated && is_active;
      if (display_moi_price) {
        $('.moi,.mapi').show();
      } else if (signed_in) {
        $('.mapi').show();
        $('.moi').hide();
      } else if (rememberMe){
        $('.mapi').hide();
        $('.moi').show();
      } else {
        $('.moi,.mapi').hide();
        $('.mapi').parent().find('.map-item').removeClass('hide');
      }
    },
    
    /**
     * If the user is signed in and has a Costco membership number stored,
     * show the Select Options or Sign in for Price Button
     * @return {[void]}
     */
    display_SelectOrSignInButton: function() {
      let member_cookie = this.getMemberCookie();
	      $('.product-tile-set').each(function(element, index){
	  	    if($(this).find('.member-only').length >0 ){
	  	    	if(member_cookie.signedIn){
	  	    		$(this).find('.select-option-button, .see-details-button').removeClass('hide');
	  	    	}else{
	  	    		$(this).find('.sign-in-button').removeClass('hide');
	  	    	}
	  	    } else if($(this).find('#mapItem').length > 0 && !member_cookie.signedIn) {
	  	    	$(this).find('.sign-in-button').removeClass('hide');
	  	    } else {
	  	    	$(this).find('.select-option-button, .see-details-button').removeClass('hide');
	  	    }
	  	 });
    },
    /**
     * This is used by inline links to pop the email offers modal. It is
     * attached to the TopRow_ESpot_4 "Sign Up" link but can be used anywhere
     * a "get email offers" modal is necessary.
     * @return {[void]}
     */
    get_email_offers: function() {
      COSTCO.dialog.createExtDialogBox({
        title: messages.RWD_GET_EMAIL_OFFERS,
        body: this.tmpl('tmpl_email_offers', {}),
        primary: messages.EMAIL_BUTTON_TITLE,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: function() {
          !$('#costcoModal p.success').length > 0 ? $('#costcoModal form').submit() : $('#costcoModalBtn2').hide();
        },
      });
    },
    /**
     * This function is the entry point for the front-end citi credit card
     * application process.  The business includes this javascript in an <a onclick/>,
     * which will initiate the ajax call.  From here, the path can go 2 different ways
     * 1.  	If the user has authorized users, they are provided with a dialog, allowing
     * 		them to choose from a list of authorized users, or none at all.
     * 2.	If the baseUrl is not included an the whitelist, it will show the
     * 		external link dialog to user, otherwise it will open a new tab to the url.
     */
    getBrandFolderVideo: function(assetKey,folderkey) {
    	var baseUriForBrandfolder=$('#baseUriForBrandfolder'+folderkey).val();
    	var bearerTokenForBrandfolder=$('#bearerTokenForBrandfolder').val();
    	var bfHeaders={};
		bfHeaders["Authorization"]=bearerTokenForBrandfolder;
	 	fetch(baseUriForBrandfolder+assetKey, {
		  method: "GET",
		  headers: bfHeaders
		})
		.then(response => {
		 if (response.status >= 200 && response.status <= 299) {
			 		return response.json();
		 } else {
			 		throw Error(response.statusText);
		 }
		 })
		.then(jsonResponse => {
				   var title = "";
				   try {
					   title = jsonResponse.data[0].attributes.name;
				   } catch (e) {
				       console.log('Title could not be retrieved from BrandFolder');
				   }
				   window.eventBus.publish('popupShow',{asset_key: assetKey,title:title,bfFolderType:folderkey});
				}).catch((error) => {
					console.log(error);
				});
    },
    applyForCostcoCredit: function(baseUrl, authorizedMemNum) {
      COSTCO.util.ajaxSend();
      if (typeof(PageAnalyticsInfo) !== 'undefined') {
        var pageType = PageAnalyticsInfo.pageType;
      }
      $.ajax({
        type: 'POST',
        url: 'https://' + location.hostname + '/ApplyForCostcoCredit',
        dataType: 'jsonp',
        data: {
          'authorizedMemNum': authorizedMemNum,
          'pageType': pageType,
        },
        success: function(parsedDataJson) {
          // Show dropdown of member numbers to choose
          if (parsedDataJson.errorCode) {
            if (parsedDataJson.errorCode == 2510) // session timeout
            {
              document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
              return;
            }
          }

          let data = parsedDataJson.applicationPrepopData;
          let token = '';
          let citiRedirectUrl = '';
          let authorizedMembersJsonArray = [];

          if(data) {
            token = data.CITI_MEMBERDATA_SIGNED_ENCRYPTED;
          }

          if (baseUrl && token) {
            citiRedirectUrl = `${baseUrl}${token}`;
          }
          
          let payloadJson = {
            'applicationPrepopData': data,
          };

          if (parsedDataJson.authorizedMembers) {
            authorizedMembersJsonArray = $.parseJSON(parsedDataJson.authorizedMembers);
          }
          //TO-DO: hiding authorizedMember selection modal until funitonality is implemented on backend. 
          // if (authorizedMembersJsonArray != undefined && authorizedMembersJsonArray.length > 0) {
          //   util.createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray);
          // } else 
          if(citiRedirectUrl) {
            util.createCostcoCreditApplyExtPrefillDialog(citiRedirectUrl);
          } else {
            util.createCostcoCreditApplyExtPrefillDialog(baseUrl);
          }
        },
        error: function(x, t, m) {
          COSTCO.util.LoginTimeout.updateActivity();
          if (t === 'timeout') {
            console.log('timout with server');
          } else {
            console.log('unexpected error TODO');
          }
          console.log('set return codes for caller of this service TODO');
        },
        complete: function() {
          COSTCO.util.ajaxComplete();
        },
      });
      return false;
    },
    /**
     * This is the dialog, allowing users to select authorized users for their citi
     * application.  This function is referenced solely in applyForCostcoCredit().
     */
    createMemberNumberSelectDialog: function(baseUrl, payloadJson, authorizedMembersJsonArray) {
      let dialogDiv = $(this.tmpl('tmpl_costco_cc_additional_member', {}));
      dialogDiv.find(':selected').val(payloadJson);
      let memberSelect = dialogDiv.find('select');
      for (let i = 0; i < authorizedMembersJsonArray.length; i++) {
        memberSelect.append($('<option>', {
          value: {
            'applicationPrepopData': authorizedMembersJsonArray[i].memberPayload,
          },
        }).text(authorizedMembersJsonArray[i].name));
      }
      COSTCO.dialog.createExtDialogBox({
        title: messages.JS_DIALOG_AUTHORIZED_USER_TITLE,
        body: dialogDiv,
        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: function() {
          let authorizedMemNum = $('#authorized-member-select').val();
          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
          $('.costcoModalBtn1').first().click();
        },
      });
      return false;
    },
    createCostcoCreditApplyExtDialog: function(baseUrl, payloadJson) {
      let dialogDiv = $(this.tmpl('tmpl_costco_cc_apply_confirm', {}));
      COSTCO.dialog.createExtDialogBox({
        title: messages.JS_DIALOG_LEAVING_SITE_TITLE,
        body: dialogDiv,
        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: function() {
          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
          $('.costcoModalBtn1').first().click();
        },
      });
      return false;
    },
    /**
    * External link dialog for Citi application prefill.
    */
    createCostcoCreditApplyExtPrefillDialog: function(url) {
      COSTCO.dialog.createExtDialogBox({
        title :  messages.JS_DIALOG_EXTERNAL_LINK,
        body :messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
        secondary: messages.JS_DIALOG_CANCEL,
        primary : messages.JS_DIALOG_EXTERNAL_LINK,
        primary_event: function() {
          document.location.href = url;
          COSTCO.dialog.close();
        },
      });
    },
    /**
     * This shows or hides all citi application links based on certain criteria.
     */
    showAllCappLinks: function(isShow) {
      if (isShow == undefined || isShow) {
        $('.citi_credit_app_link').show();
      } else {
        $('.citi_credit_app_link').hide();
      }
    },
    /**
     * This processes the business cases for when users should not be allowed to apply
     * for citi credit cards.  Links will be hidden, and other text will be shown instead.
     * For the case where text is shown instead, the business must set this up via CMC.  Please
     * reference the run documentation provided.
     */
    processCappLogic: function() {
      let capp_json = util.getCappJson();
      if (capp_json != null) {
        if (capp_json.coBrandedCreditMax) {
          // hide all application links
          util.showAllCappLinks(false);
        } else if (capp_json.displayErrorForRenew) {
          // show message and hide all application link
          $('#displayErrorForRenew').show();
          util.showAllCappLinks(false);
        } else if (capp_json.displayErrorForCancel) {
          // show message and hide all application links
          $('#displayErrorForCancel').show();
          util.showAllCappLinks(false);
        } else if (capp_json.displayErrorForRenewGSHousehold) {
          // show message and hide all application links
          $('#displayErrorForRenewGSHousehold').show();
          util.showAllCappLinks(false);
        } else {
          // show credit app links
          util.showAllCappLinks(true);
        }
      } else {
        // show credit app links
        util.showAllCappLinks(true);
      }
    },
    /**
     * Updates the cookie json with the business logic encapsulated in these
     * attributes.
     */
    updateCappJson: function(data) {
      let capp_json = {};
      capp_json.coBrandedCreditMax = typeof data !== 'undefined' ?
        data.coBrandedCreditMax :
        MembershipMetaData.payload.caller.coBrandedCreditMax;
      capp_json.displayErrorForRenew = typeof data !== 'undefined' ?
        data.displayErrorForRenew :
        MembershipMetaData.payload.caller.displayErrorForRenew;
      capp_json.displayErrorForCancel = typeof data !== 'undefined' ?
        data.displayErrorForCancel :
        MembershipMetaData.payload.caller.displayErrorForCancel;
      capp_json.displayErrorForRenewGSHousehold = typeof data !== 'undefined' ?
        data.displayErrorForRenewGSHousehold :
        MembershipMetaData.payload.caller.displayErrorForRenewGSHousehold;
      $.cookie('capp_json', JSON.stringify(capp_json), {
        expires: 30,
        path: '/',
      });
    },
    /**
     * Retrieves citi cookie and converts to json.
     */
    getCappJson: function() {
      let capp_json = $.cookie('capp_json');
      if (capp_json != null) {
        capp_json = JSON.parse(capp_json);
      }
      return capp_json;
    },
    /**
     * Create external post form, to be used in a dialog (if on whitelist)
     * or incorporated into the external link dialog.  dataJson is converted
     * into hidden inputs to pass in the form. Form opens to new tab.
     */
    dynamicExternalFormPost: function(url, dataJson) {
      let dynamicPostForm = $('<form method=\'POST\' action=\'' + url + '\' target=\'_blank\' enctype=\'multipart/form-data\'></form>');
      for (let key in dataJson) {
        if (dataJson.hasOwnProperty(key)) {
          dynamicPostForm.append($('<input type=\'hidden\' name=\'' + key + '\' value=\'' + dataJson[key] + '\'/>'));
        }
      }
      // Pushing the form into the DOM and then submitting, IE complains if not done.
      $('body').append($('<div id=\'external_link\' style=\'display:hidden\'/>').append(dynamicPostForm.clone()));
      $('#external_link form').submit();
      $('#external_link form').remove();
    },
    /**
     * Ajax spinner for send.
     */
    ajaxSend: function() {
      if ($('#dataGlobalSpinner').length == 0) {
        let spinner = '<div class="ui-widget-overlay ui-front r1_spinner" id="dataGlobalSpinner"></div>';
        $('body').append(spinner);
      } else {
        $('#dataGlobalSpinner').append('<div/>');
      }
    },
    /**
     * Ajax spinner for completion.  Multiple ajax spinners could be going, so this
     * will only take one out with each call.
     */
    ajaxComplete: function() {
      let spinner = $('#dataGlobalSpinner');
      if (spinner.length > 0 && spinner.children().length == 0) {
        spinner.remove();
      } else {
        $(spinner.children()[0]).remove();
      }
    },
    /**
     * Login timeout logic incorporated from legacy js that is referenced.
     */
    LoginTimeout: {
      redirectView: '/LogonForm',
      lastActivity: '',
      checkTimeout: function() {
        if (COSTCO.util.LoginTimeout.lastActivity == '') {
          return;
        }
        let now = new Date().getTime();
        let diff = now - (COSTCO.util.LoginTimeout.lastActivity);
        if (diff > wcs.loginTimeOut) {
          window.location.href = COSTCO.util.LoginTimeout.redirectView;
          throw new Error('Stale browser - redirecting');
        }
      },
      updateActivity: function() {
        COSTCO.util.LoginTimeout.lastActivity = new Date().getTime();
      },
    },
    /**
     * Get a parsed object from localStorage (if localStorage is available).
     * @param  {[item]} item - the key to pull from localStorage
     * @return {[object]} storage_item - the object representing the string
     *  in local storage (or empty object in the case of the item not existing)
     */
    getFromStorage: function(item) {
      let storage_item = {};
      if (localStorage) {
        storage_item = localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : {};
      }
      return storage_item;
    },
    /**
     * Set a string/object in localStorage for later use (if localStorage is available)
     * @param {[string]} name - key to reference the value
     * @param {[string|object]} item - value to store in localStorage
     */
    setInStorage: function(name, item) {
      var item = typeof item === 'string' ? item : JSON.stringify(item);
      if (localStorage) {
        localStorage.setItem(name, item);
      }
    },
    /**
     * Get a parsed object from sessionStorage (if sessionStorage is available).
     * @param  {[item]} item - the key to pull from sessionStorage
     * @return {[object]} storage_item - the object representing the string
     *  in session storage (or empty object in the case of the item not existing)
     */
    getFromSession: function(item) {
      let storage_item = {};
      if (sessionStorage) {
        storage_item = sessionStorage.getItem(item) ? JSON.parse(sessionStorage.getItem(item)) : {};
      }
      return storage_item;
    },
    /**
     * Set a string/object in sessionStorage for later use (if sessionStorage
     * is available)
     * @param {[string]} name - key to reference the value
     * @param {[string|object]} item - value to store in sessionStorage
     */
    setInSession: function(name, item) {
      var item = typeof item === 'string' ? item : JSON.stringify(item);
      if (sessionStorage) {
        sessionStorage.setItem(name, item);
      }
    },
    /**
     * Remove object from sessionStorage (if sessionStorage is available).
     * @param  {[name]} name - key for item to be removed from sessionStorage
     * @return none
     *
     */
    removeFromSession: function(name) {
      if (sessionStorage) {
        sessionStorage.removeItem(name);
      }
    },
    /**
     * Shamelessly stolen from stackoverflow. Get the query string by name
     * @param  {[type]}
     * @param  {[type]}
     * @return {[type]}
     */
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    /**
     * Shamelessly stolen from stackoverflow. Adds a single parameter to the URL 
     * @param  {[type]}
     * @param  {[type]}
     * @return {[type]}
     */
    insertParamInUrl: function (key, value) {
      key = encodeURIComponent(key);
      value = encodeURIComponent(value);
      var kvp = document.location.search.substr(1).split('&');
      let i=0;
      for(; i<kvp.length; i++){
          if (kvp[i].startsWith(key + '=')) {
              let pair = kvp[i].split('=');
              pair[1] = value;
              kvp[i] = pair.join('=');
              break;
          }
      }
      if(i >= kvp.length){
          kvp[kvp.length] = [key,value].join('=');
      }
      let params = kvp.join('&');
      return params;
    },
    /**
     * Returns an object representing query string parameters.
     * @return {[object]} The object represeting query strings
     *                        &isAwesome=true becomes
     *                        {"isAwesome":"true"}
     */
    get_parameters_as_object: function() {
      return document.location.search.replace(/(^\?)/, '').split('&').map(function(n) {
        return n = n.split('='), this[n[0]] = n[1], this;
      }.bind({}))[0];
    },
    all: function(arr, p) { // from haskell's data.list
      let test = true;
      arr.forEach(function(x) {
        if (!p(x)) {
          test = false;
          return;
        }
      });
      return test;
    },
    /**
     * Returns True if at least one item in the array fulfills the condition
     * @param  {[array]}    arr - the array to test
     * @param  {[function]} p - the predicate function to test against the array
     * @return {Boolean}
     */
    any: function(arr, p) {
      let answer = false;
      for (let i = 0, len = arr.length; i < len; i++) {
        if (answer) break;
        if (p(arr[i])) {
          answer = true;
          break;
        }
      }
      return answer;
    },
    hasElem: function(elem, array) {
      let hasit = false;
      array.forEach(function(e, i) {
        if (elem === e) hasit = true;
        return;
      });
      return hasit;
    },
    localeSpecificCurrency: function(v, loc, c) {
      let n = parseFloat(v);
      if (isNaN(v)) return v;
      c = typeof(c) != 'undefined' ? c : 2;
      switch (loc) {
        case 'fr':
          return this.formatCurrency(n, c, ',', ' ') + ' $';
        default:
          return '$' + this.formatCurrency(n, c, '.', ',');
      }
    },
    formatCurrency: function(n, c, d, t) {
      var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? ',' : d,
        t = t == undefined ? '.' : t,
        s = n < 0 ? '-' : '',
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
    },
    formatMoney: function(number, has_symbol) {
      var number = (Math.round(number * 100) / 100).toString(),
        dollars = number.split('.')[0],
        cents = (number.split('.')[1] || '') + '00';
      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''),
        symbol = has_symbol ? '$' : '';
      let locale = COSTCO.util.getLocale();
      if (locale == 'fr-CA') {
        return dollars.split(',').join(' ') + ',' + cents.slice(0, 2) + ' ' + symbol;
      }
      return symbol + dollars + '.' + cents.slice(0, 2);
    },
    formatPhone: function(number) {
      if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
        return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      } else {
    	return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
    },
    // public method for encoding
    encode: function(input) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;
      input = COSTCO.util._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
      }
      return output;
    },
    // public method for decoding
    decode: function(input) {
      let output = '';
      let chr1, chr2, chr3;
      let enc1, enc2, enc3, enc4;
      let i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      while (i < input.length) {
        enc1 = this._keyStr.indexOf(input.charAt(i++));
        enc2 = this._keyStr.indexOf(input.charAt(i++));
        enc3 = this._keyStr.indexOf(input.charAt(i++));
        enc4 = this._keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = COSTCO.util._utf8_decode(output);
      return output;
    },
    // private method for UTF-8 decoding
    _utf8_decode: function(utftext) {
      let string = '';
      let i = 0;
      let c = c1 = c2 = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if ((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    // private method for UTF-8 encoding
    _utf8_encode: function(string) {
      string = string.replace(/\r\n/g, '\n');
      let utftext = '';
      for (let n = 0; n < string.length; n++) {
        let c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    },
    /**
     * Hard coded the locales as our current implementation only supports 3
     * locales. Also application logic can override the default browser
     * locale
     */
    getLocale: function() { 
      let langId = this.getLangId();
      if (langId == -1) return 'en-US';
      if (langId == -24) return 'en-CA';
      if (langId == -25) return 'fr-CA';
      return 'en-US';
    },
    isSafari: function() {
      let is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
      let is_safari = navigator.userAgent.indexOf('Safari') > -1;
      if ((is_chrome) && (is_safari)) {
        is_safari = false;
      }
      return is_safari;
    },
    /**
     * Function once ran will copy the dom to nodes as needed - helps to avoid a server "DOM Bomb", but places that load on the client
     *
     * Required to define placement and content params
     *
     * Options can be overriden as needed to use different classes depending how the responsive content is setup.
     */
    responsivePlacement: function(options) {
      let opt = { 
        placement: '',
        content: '',
        useInnerContent: true,
        display: 'block',
        DESKTOP: '.visible-xl-',
        TABLETLANDSCAPE: '.visible-lg-',
        TABLETPORTRAIT: '.visible-md-',
        PHONELANDSCAPE: '.visible-sm-',
        PHONEPORTRAIT: '.visible-xs-',
      };
      $.extend(opt, options);
      let node = $(opt.placement + opt.content);
      if (node.length < 1) {
        console.log('Missing Content for RespnsivePlacement');
        return;
      }
      let content = '';
      if (opt.useInnerContent) content = node.html();
      else {
        content = node;
      }
      if ($(opt.placement).find('[itemprop=name]')) {
    	  $(opt.placement).find('[itemprop=name]').removeAttr('itemprop'); 
      }
      
      COSTCO.util.responsiveContent(opt.placement, opt.DESKTOP + opt.display, content);
      COSTCO.util.responsiveContent(opt.placement, opt.TABLETLANDSCAPE + opt.display, content);
      COSTCO.util.responsiveContent(opt.placement, opt.TABLETPORTRAIT + opt.display, content);
      COSTCO.util.responsiveContent(opt.placement, opt.PHONELANDSCAPE + opt.display, content);
      COSTCO.util.responsiveContent(opt.placement, opt.PHONEPORTRAIT + opt.display, content);
      return;
    },
    responsiveContent: function(selector, nodeClass, content) {
      let node = $(selector + nodeClass);
      if (node.length <= 0) {
        return;
      }
      if (node.html().trim().length <= 0) {
        node.append(content);
      }
      return;
    },
    getQueryStringArray: function() {
      let queryString = [];
      let a = window.location.search.substr(1).split('&'),
        b;
      for (let i = 0; i < a.length; i++) {
        b = a[i].split('=');
        queryString[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
      }
      return queryString;
    },
    /**
     * Taken from Underscore.js (http://underscorejs.org/)
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    debounce: function(func, wait, immediate) {
      let timeout;
      return function() {
        let context = this,
          args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
      };
    },
    isElementInViewport: function(el) {
      if (el.length <= 0) {
        return false;
      }
      let rect = el[0].getBoundingClientRect();
      return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 600 && /* or $(window).height() */ rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ );
    },
    onVisibilityChange: function(el, callback) {
      return function() {
        let visible = COSTCO.util.isElementInViewport(el);
        if (visible == true) {
          if (typeof callback == 'function') {
            callback();
          }
        }
      };
    },
    /**
     * Decode an HTML encoded string. Turns stuff like this
     * '&lt;p&gt;name&lt;/p&gt;&lt;' and converts it to '<p>name</p>'
     * @param  {String} encodedHtmlString The html string to decode
     * @return {String}                   The decoded html string.
     */
    get_decoded_html: function(encodedHtmlString) {
      let textArea = document.createElement('textarea');
      textArea.innerHTML = encodedHtmlString;
      return textArea.value;
    },
    /**
     * Inject an arbitrary number of hidden inputs into a given form. Meant
     * to be a utility to prevent statically adding key/values to $.ajax.
     * Just use this function and then serialize the form with $.fn.serialize.
     * Note that this function will only inject an input into a form if the
     * named input doesn't already exist.
     * @param  {String} form   The form selector
     * @param  {Object} inputs The object representing the key/values to
     *                         be inserted into the form as inputs
     *                         {key:'value'}
     * @return {void}
     */
    input_injector: function(form, inputs) {
      let html = '';
      Object.keys(inputs).forEach(function(key) {
        if ($(form + ' input[name=' + key + ']').length == 0) {
          html += '<input type=\'hidden\' name=\'' + key + '\' value=\'' + inputs[key] + '\'/>';
        }else if (key=== 'prescriptionId'|| key === 'isPharmacy'){
        	$(form + ' input[name=' + key + ']').val(inputs[key]);
        }
      });
      $(form).append(html);
    },
    iosModalWhiteSpace: function(selectorArray) { // hide the native soft keyboards
      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
        selectorArray.forEach(function(selector) {
          let formElements = $(selector + ' input,' + selector + ' select,' + selector + ' textarea');
          $(formElements).unbind('focus.iosModalWhiteSpace').on('focus.iosModalWhiteSpace', function() {
            $(selector).css({
              position: 'absolute',
            });
          });
          $(formElements).unbind('blur.iosModalWhiteSpace').on('blur.iosModalWhiteSpace', function() {
            $(selector).css({
              position: 'fixed',
            });
            window.scrollTo(0, 0);
          });
        });
      }
    },
    /**
     * This fixes the case where the cursor sits outside of the focused input
     * on iOS devices. It has the unfortunate side effect of scrolling
     * to the top of the page when the modal is overlayed.
     * @return {void}
     */
    iosPositionFix: function() {
      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
        let style = $('<style>body.modal-open { position: fixed; }</style>');
        $('html > head').append(style);
      }
    },
    /**
     * Check if the application is running on the costco mobile app
     */
    isRunningOnMobileApp: function() {
    	return (typeof Android != 'undefined' || typeof webkit != 'undefined');
    	//return true;
    },
    /**
     * This function compares UserAgent header with mobile pattern regex. If mobile browser is not detected with this way,
     * it checks if screen width is 1024 or less, which is also being treated as a mobile browser.
     * 
     * @returns True if mobile browser is detected
     */
    isMobile: function() {
    	let detectedMobileWithRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Nokia|UCWEB/i.test(navigator.userAgent.toLowerCase());
    	let detectedMobileByScreenSize = $(window).width() <= 1024;
        return detectedMobileWithRegex || detectedMobileByScreenSize;
    },
    /**
     * Generates random UUID number
     */
    createUUID: function() {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          let r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      return uuid;
    },
    /**
     * Generic ajax wrapper. Set promise handlers inside the options
     * object. ie options.done: function(){} will be called when the
     * request is finished. Options object also gets passed back the
     * the promise functions. Look at the signures below.
     * @param  {Object} options The object used to pass options.
     *                          {done: function(){}, hi: 'robert'}
     * @return {jQuery.Deferred} The deferred object generated by calling
     *                           $.ajax which can be chained.
     */
    ajax: function(options) {
      let done;
      let fail;
      let always;
      let beforeSend = options.beforeSend || undefined;
      let complete = options.complete || undefined;
      options.done ? done = options.done : undefined;
      options.fail ? fail = options.fail : undefined;
      options.always ? always = options.always : undefined;
      // Defaulting adding/removing the "busy" class as a decorator
      // for beforeSend and complete
      beforeSend
        ?
        options.beforeSend = function(jqXHR, settings) {
          $('.order-ajax').addClass('ajax-busy');
          beforeSend(jqXHR, settings);
        } :
        options.beforeSend = function(jqXHR, settings) {
          $('.order-ajax').addClass('ajax-busy');
        };
      complete
        ?
        options.complete = function(jqXHR, textStatus) {
          $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
          complete(jqXHR, textStatus);
        } :
        options.complete = function(jqXHR, textStatus) {
          $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
        };
      return $.ajax(options).done(function(data, textStatus, jqXHR) {
        if (done) done(data, textStatus, jqXHR, options);
      }).fail(function(jqXHR, textStatus, errorThrown) {
        if (fail) fail(jqXHR, textStatus, errorThrown, options);
      }).always(function(data, textStatus, jqXHR) {
        if (always) always(data, textStatus, jqXHR, options);
      });
    },
    /**
     * Used by jquery.validate on "validate" function options to scroll to the
     * first error in the list.
     * @param  {object} event     The event on the form
     * @param  {object} validator The validator object associated with the form
     * @return {void}
     */
    invalid_handler: function(event, validator) {
      if (!validator.numberOfInvalids()) return;
      let base = $('#costcoModal').hasClass('in') ? '#costcoModal' : 'html, body';
      base == '#costcoModal' ?
        $(base).scrollTo(validator.errorList[0].element, 100) :
        $(base).scrollToElem(validator.errorList[0].element, 100);
      validator.errorList[0].element.focus();
    },
    /**
     * Check to see if a particular path is part of the checkout flow.
     * @param  {String}  pathname The path (document.location.pathname)
     * @return {Boolean}          Is this path part of the checkout flow?
     */
    isCheckout: function(pathname) {
      let isCheckout = false;
      if (pathname == '/CheckoutCartView' || pathname == '/CheckoutCartDisplayView' || pathname == '/CheckoutPaymentView' || pathname == '/CheckoutShippingView' || pathname == '/CheckoutReviewView') {
        isCheckout = true;
      }
      return isCheckout;
    },
    triggerClickOnEnterKeyPress: function(inputSelector, clickSelector) {
      $(inputSelector).unbind('keypress').on('keypress', function(event) {
        if (event.which == 13) {
          $(clickSelector).click();
          return false;
        }
      });
    },
    /**
     * Takes a base url and appends query strings to it. Joining the
     * base and querystring with the appropriate separator '&' or '?'
     * @param  {string} base           The string to append query strings to
     *                                 '/order-item-update' or 'www.costco.com'
     * @param  {object} querystringObj The object representing the querystrings
     *                                 to append ie '{checkoutPage: 'review'}'
     * @return {string}                The made url with querystrings attached.
     */
    makeUrl: function(base, querystringObj) {
      let sep = (base.indexOf('?') > -1) ? '&' : '?';
      return base + sep + $.param(querystringObj);
    },
    /**
     * Did the ajax response object return any application or system errors?
     * @param  {object}  response_obj The parsed response object from calling
     *                                any backend class that resolves to
     *                                JSONLayout.jsp
     * @return {Boolean}              Does it have application or system errors?
     */
    has_errors: function(response_obj) {
      let application = response_obj.error.application;
      let exception = response_obj.error.exception;
      return application.length > 0 || exception.length > 0;
    },
    messageFormat: function(format) {
      let args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
      });
    },
    /**
     * This function restricts membership number inputs to numeric user input.
     * The input must be of type=text for it to work.
     * @return {void}
     */
    maskMembershipInput: function() {
      $('[name=userField2], [name=membershipNumber], [name=membershipId], [name=membershipNumberToVerify]').mask('#');
    },
    addToWishList: function(catentryId, fromPage) {
      window.location.href = COSTCO.util.makeUrl('/AddToWishListView', {
        catentryId: catentryId,
        fromPage: fromPage || '',
      });
    },
    isBusinessDelivery: function() {
      if ($('#isBDAppVar') && $('#isBDAppVar').length > 0) {
        currentSite = $('#isBDAppVar').val();
        if (currentSite == 'BD') {
          return true;
        }
      }
      return false;
    },

    /**
     * To initialize global grocery flag. Determine whether grocery product is displayed in the page or not.
     * @return {Boolean} hasGroceryProducts
     */
    hasGroceryProducts: function() {
      let hasGroceryProducts = false;
      if ($('#hasGroceryPdts').length > 0) {
        let globalFlag = $('#hasGroceryPdts').val();
        if (null != globalFlag && globalFlag == 'true') {
          hasGroceryProducts = true;
        }
      }
      return hasGroceryProducts;
    },
    /**
     * Determine the default grocery home page url
     * @return {String} groceryHomepageURL
     */
    groceryDefaultHomepage: function() {
      let groceryHomepageURL = '';
      if ($('#groceryDefaultHomepage').length > 0) {
        groceryHomepageURL = $('#groceryDefaultHomepage').val();
      }
      return groceryHomepageURL;
    },
    isCAStore: function() {
      let isCAStore = false;
      if (null != wcs.storeId && wcs.storeId == '10302') {
        isCAStore = true;
      }
      return isCAStore;
    },
    isCABDStore: function() {
      let isCAStore = false;
      if (null != wcs.storeId && wcs.storeId == '11303') {
        isCAStore = true;
      }
      return isCAStore;
    },
    isUSBDStore: function() {
  	  let isBDStore = false;
  	  if (null != wcs.storeId && wcs.storeId == '11301') {
  	    isBDStore = true;
  	  }
  	  return isBDStore;
  	},
    isBDStore: function() {
        let isBDStore = false;
        if (null != wcs.storeId && wcs.storeId != '10301' && wcs.storeId != '10302') {
          isBDStore = true;
        }
        return isBDStore;
     },
    isUSStore: function() {
      let isUSStore = false;
      if (null != wcs.storeId && wcs.storeId == '10301') {
        isUSStore = true;
      }
      return isUSStore;
    },
    is2DayEligbleRegn: function() {
      let isRegionValid = 'false';
      if ($.cookie('C_2LOC') != null) {
        isRegionValid = $.cookie('C_2LOC');
      }
      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
        return false;
      }
      return true;
    },
    logToClickTale: function(message, url, lineNumber) {
      if (typeof window.onerror !== 'function') {
        console.log('onerror is not a function');
      }
      try {
        if (typeof message === 'object') {
          message = JSON.stringify(message);
        }
        window.onerror(message, url, lineNumber);
      } catch (e) {
        console.log('Unknown error logging to Clicktale');
      }
    },
    getSource: function() {
        let locale = util.getLocale().slice(3,5).toUpperCase();
        let store = util.isBDStore() ? 'BD': 'BC';
        return locale + store;
    },
    // Begin Business Delivery Client Cookies
    getBDZipCookie: function() {
      let z = $.cookie('WC_BD_ZIP'),
        w = $.cookie('WC_BD_WHS'),
        ec = '',
        originalZipCode =  $.cookie('WC_BD_ZIP_ORIGINAL');
      if (z == null || z == '""') {
        z = '';
      }
      if (originalZipCode == null || originalZipCode == '""') {
    	  originalZipCode = '';
      }      
      if (w == null || w == '""') {
        w = '';
      } else {
        if (w.indexOf('-') != -1) {
        	//STRY0140687 BD-National Delivery-Check the presence of EC to identify the residential flow.
        	if (w.indexOf('ND') != -1) {
        		let whsArray = w.split('-');
            	if(whsArray.includes('ND')) {
            		ec = 'ND';
            	}
        	}
          w = w.substring(0, w.indexOf('-'));
        }
      }
      z = z.replace(/\+/g, ' ');
      originalZipCode = originalZipCode.replace(/\+/g, ' ');
      return {
        zipCode: z,
        warehouseNumber: w,
        externalCarrier: ec,
        originalZipCode: originalZipCode
      };
    },
    getMaxOutherHeight: function(elems) {
      return Math.max.apply(null, elems.map(function() {
        return $(this).outerHeight(true);
      }).get());
    },
    isDepotCatalogEnabled: function() {
      	var depotCatalogEnableFlag = $('#depotCatalogEnableFlag').length > 0 && $('#depotCatalogEnableFlag').val()=='true' ? true:false;      	
      	return depotCatalogEnableFlag;
     },
     isNdEnabled: function() {
    	 if($('#isNdEnabled').val() == 'true'){
    		 return true;
    	 } else {
    		 return false;
    	 }
     },
     isEDDEnabled: function() {
    	var eddEnabled = true;
       	if (COSTCO.util.checkElementById('#vendorName', 'EDD:CHUBSmallPack') && !COSTCO.util.checkElementById('#eddSmallPackEnabled','true')){
       		eddEnabled = false
       	}
       	return eddEnabled;
      },
      
     isExternalCarrierShipmode: function() {
    	var shipmodeId = '';
 		if(COSTCO.util.isNdEnabled() && ($('input[name="deliveryMethod"]').length>0 || $('#shipmodeId').length>0)){
 	    	shipmodeId = $('input[name="deliveryMethod"]').length>0?$('input[name="deliveryMethod"]:checked').val():$('#shipmodeId').val();
 		}
 		if(shipmodeId == '10102' || shipmodeId == '10104'){
 			return true;
 		} else {
 			return false;
 		}
     },
     
     isExternalCarrierShipmodeValue: function(shipmodeId) {
       if(COSTCO.util.isNdEnabled() && shipmodeId.length>0 && (shipmodeId == '10102' || shipmodeId == '10104')) {
         return true;
       } else {
         return false;
       }
     },
     
     /**
      * Check if first search suggestion exists and set it to
      * screen reader announcement div
      */
     setFirstSuggestionAnnouncement : function() {
         if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0 && $('.tt-menu').find('.tt-cursor').length === 0) {
             var firstSuggestion = $('.tt-suggestion:first').text();
             $('#announce-first-suggestion').text(firstSuggestion);
         }
     },
 	
 	 /**
      * Announce first suggestion (if any) after user's inactivity 
      */
     announceFirstSuggestion: function() {
         if ($('#announce-first-suggestion').length > 0) {
             $('#announce-first-suggestion').text('');
         }
         window.clearTimeout(this.timeout);
         timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
     },
     /**
      * This is to define the constants for the product availablity check
      */
     productConstants : {
    	 inv_backorderd : 'BACK_ORDER',
    	 inv_outOfStock : 'OUT_STOCK',
    	 inv_invalidSku : 'INVALID_ITEM',
    	 zipcodeAvailCheck_StatusFail : 'FAIL',
    	 check_StatusSuccess : 'success',
    	 edd_shiprestricted: 'SHIPRESTRICTED',
    	 edd_backordered: 'BACKORDERED',
    	 edd_presell : 'PRESELL',
     },
    /**
     * Notification object for notification message display.
     */
    notification: {
      /**
       * Constants for notification display.
       */
      type: {
        SUCCESS: 'SUCCESS',
        WARNING: 'WARNING',
        ERROR: 'ERROR',
      },
      /**
       * Displays notification on screen.
       * @param {string}  notificationType     Type of notification message to display (SUCCESS | WARNING | ERROR)
       * @param {Array}   notifications        Array of notification messages to be displayed in the notification box
       * @param {boolean} scrollToNotification Scroll window to notification message
       * @param {Jquery element}  element           Jquery element for notification display
       */
      displayNotification: function(notificationType, notifications, scrollToNotification, $element, wrapper) {
        $element = ($element && $($element).length > 0) ? $($element) : $('#notification-message');
        scrollToNotification = (scrollToNotification) ? scrollToNotification : false;

        this.clearNotification($element);

        let topNotificationClass = '';
        let topNotificationInnerHtml = '';

        switch (notificationType) {
          case this.type.SUCCESS:
            topNotificationClass = 'success-notification';
            break;
          case this.type.WARNING:
            topNotificationClass = 'warning';
            break;
          case this.type.ERROR:
            topNotificationClass = 'critical-notification';
            break;
          default:
            break;
        }
        let elementWrapper = wrapper ? wrapper : 'p';
        notifications.forEach(function(notification) {
          if (typeof notification === 'object') {
            for (let errorKey in notification)
              topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification[errorKey] + '</' + elementWrapper + '>';
          } else {
            topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification + '</' + elementWrapper + '>';
          }
        });

        $element.addClass(topNotificationClass);

        topNotificationInnerHtml = COSTCO.util.get_decoded_html(topNotificationInnerHtml);
        $element.html(topNotificationInnerHtml);

        if (scrollToNotification) {
          $('body, html').animate({
            scrollTop: $element.offset().top - 30,
          }, 800);
        }

        $element.attr('tabindex', -1);
        $element.focus();
      },
      /**
       * Clears displayed notifications on screen.
       * @param {Jquery element} Jquery element for notification display.
       */
      clearNotification: function($element) {
        $element = ($element) ? $($element) : $('#notification-message');

        $element.removeClass();
        $element.html('');
      },
    },
    
    /**
     * Redirects the pages to generic error/cart on inactive conditions
     * @param page 
     * @param orderStatus 
     */
    redirectCartOnInactive: function(page,status) {
    	if($('#orderStatus').val() !== '' && $('#orderStatus').val() !== undefined ){
    		if((page === 'SHIPPING' || page === 'payment' || page === 'review' ) && status === 'INACTIVE'){
        		window.location.href = "/CheckoutCartView";
        	}else if((page === 'quick-membership' || page === 'quick-membership-renew')  && status === 'INACTIVE'){
        		window.location.href = "/GenericError";
        	}
    	}
    },
    
    /**
     * Gets element with back to top link
     * and (if exists) binds keydown and click event
     * that moves focus to top of the page
     * @param backToTopLink
     */
    setEventOnBackToTopLink: function(backToTopLinkClass){
    	let $backToTopLink = ($(backToTopLinkClass).find("a").length > 0) ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
    	/* ADA STRY0169325 - Back to top functionality */
        $backToTopLink.attr("href", "#headerskip");
        $backToTopLink.click(function() {
            COSTCO.util.scrollToTop();
        });
        $backToTopLink.keydown(function(e) {
            if(e.keyCode === 13)
                COSTCO.util.scrollToTop();
            }
        );
    },
    

    /**
     * Function used to add a label with error message accessible only to screen reader
     * @param element that error label should be attached to
     */
    addErrorLabelForAda: function (element) {
    	if ((typeof element !== 'undefined') && (element !== null)) {
    		let $element = $(element);
    		if ($element.hasClass("error") && !$element.siblings('.sr-only').length) {
    			$element.before("<span for=\"" + $element[0].id + "\" class=\"sr-only\">" + messages.ERROR + "</span>");
    		}
    	}
    },
    
    /**
     * Function used for fetching first global error message on page
     * @param containerElement - specifies the element in which the global error is searched for
     * @return first element with global error class
     */
    getFirstGlobalErrorOnPage: function(containerElement) {
      let errorClasses = COSTCO.util.globalErrorElementClasses;
      //create jquery selector from an array of classes
      let selector = errorClasses.join(", .");
      let firstElementWithClass = containerElement.find('.' + selector).html() !== undefined ? containerElement.find('.' + selector).first() : null;
      let iterationValue = firstElementWithClass;
      while (iterationValue !== undefined && iterationValue !== null) {
    	firstElementWithClass = iterationValue;
    	iterationValue = COSTCO.util.getFirstGlobalErrorOnPage(firstElementWithClass);
      }
      return firstElementWithClass;
    },

    /**
     * Function that creates an error label accessible only to screen reader
     * @param errorMessage that should be appended with screen reader label
     * @return string containing both the error message and the screen reader only error label
     */
	createErrorAdaLabel: function(errorMessage) {
	  return "<span class='sr-only'>"+messages.ERROR+"</span>" + errorMessage;
    },

	/**
	 * Function used to remove a label with error message accessible only to screen reader
	 * @param element whose label should be removed
	 */
    removeErrorLabelForAda: function(element) {
    	if((typeof element !== 'undefined') && (element !== null)) {
    		let $element = $(element);
    		$element.siblings('label').remove(".sr-only");
    		$element.siblings().children('label').remove(".sr-only");
    		$element.parent().siblings('label').remove(".sr-only");
    	}
    },
    
    /**
     * jquery validator 'highlight' method,
     * with ADA error label added
     */
    highlightWithErrorLabel:  function(element, errorClass, validClass) {
		
		if (element.type === 'radio') {
			this.findByName(element.name).addClass(errorClass).removeClass(validClass);
		} else {
			$(element).addClass(errorClass).removeClass(validClass);
			$(element).attr("aria-describedby",this.idOrName(element)+this.settings.idSuffix);
		}
		COSTCO.util.addErrorLabelForAda(element);
	},
    
	/**
     * jquery validator 'unhighlight' method,
     * with ADA error label added
     */
	unhighlightWithErrorLabel:  function(element, errorClass, validClass) {
		if (element.type === 'radio') {
			this.findByName(element.name).removeClass(errorClass).addClass(validClass);
		} else {
			$(element).removeClass(errorClass).addClass(validClass);
			$(element).removeAttr("aria-describedby");
		}
		COSTCO.util.removeErrorLabelForAda(element);
	},
    
    /**
     * Function used to inject message in screen reader placeholder announcement div
     * @param message to be injected
     */
	announceSRMessage: function(message) {
      let adaMessageDiv = $('#screen-reader-announcement');
      if (message !== undefined && message.length !== 0 && message !== "") {
        adaMessageDiv.empty();
        adaMessageDiv.html(message);
        
        //after a 2sec delay, remove the message so SR users don't unneccessarily revisit it when navigating DOM
        setTimeout(() => { adaMessageDiv.empty(); }, 2000);
      }
    },
    
    /**
     * Calling function onclick by pressing enter key (keyCode = 13)
     * @param id
     */
    clickElementOnEnter: function(elementId) {
      if (event.keyCode === 13 && $('#' + elementId).length > 0) {
        $('#' + elementId).click();
      }
    },
    
    /**
     * Calling function onclick by pressing enter key (keyCode = 13)
     * or pressing space key (keyCode = 32)
     * @param id
     */
	clickElementOnEnterOrSpace: function(elementId) {
        if ((event.keyCode === 13 || event.keyCode === 32) && $('#' + elementId).length > 0) {
            //Prevents from window scrolling
            if(event.keyCode === 32){
                event.preventDefault();
            }
            //If element is tooltip, do not perfrom action
            if($(".span-inline-block").is(":focus")){
                return false;
            }
            $('#' + elementId).click();
        }
    },
    
    //Workarround for FireFox locked tabbing on radio buttons ALM #22811
    /**
     * Calling function onfocus event 
     * and changing label tabindex attr to -1
     */
	changeTabIndex: function() {
		var element = $("label[role=radio]");
		element.each(function() {               
			$(this).attr('tabindex', '-1');
    	});
	},
	
	/**
	 * Calling function onblur event making element unfocusable
	 * and changing label tabindex attr back to 0
	 * @param el (date input name)
	 */
	changeTabIndexOut: function(el) {
		if(el){
        	$(el).attr('tabindex', '0');
    	}
       	var element = $("label[role=radio]");
       	element.each(function() {               
       		$(this).attr('tabindex', '0');
       	});
	},
	
    /**
     * Calling function onfocus event making date input focusable
     * @param element (date input name)
     */
	setTabIndex: function(el){
		var element = $("input[name="+el+"]");
       	element.attr('tabindex','0');
    },
    
    /**
     * Calling function onclick by pressing Space key (keyCode = 32) 
     * referencing element by element's ID
     * @param elementId
     */
    clickElementOnSpaceBtn: function(elementId) {
      if (event.keyCode === 32 && $('#' + elementId).length > 0) {
	      //Prevents from window scrolling
	      event.preventDefault();
	      //If element is tooltip, do not perfrom action
	      if($(".span-inline-block").is(":focus")){
	      	return false;
	      }
	      $('#' + elementId).click();
      }
    },
    /**
     * Returns all focusable elements inside parent element
     * @parentElement
     */
    returnAllFocusableElements: function(parentElement){
        let focusableElements = parentElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),'
               +'textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]),'
               +'input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex="0"], area');
        return focusableElements;
    },
    /**
     * Returns all visible focusable elements from list of elements
     * @focusableElements
     */
    returnAllFocusableVisibleElements: function(focusableElements){
        let visibleFocusable = [];

        function findVisibleElements(item, index) {
			$(item).unbind('keydown');
            //Does element or its parent has display none
            if(item.style.display !== "none" && item.offsetParent !== null) {
				if ($(item).is(':visible')) {
				    visibleFocusable.push(item);
				}
            }
        }

        for (var i = 0; i < focusableElements.length; i++) {
        	findVisibleElements(focusableElements[i]);
        }
        return visibleFocusable;
    },
    /**
     * Returns focus to first/last focusable element in modal
     */
    setElementFocus: function(firstElement, lastElement, e) {
		let KEYCODE_TAB = 9;
        if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
            if ( e.shiftKey && (document.activeElement === firstElement)) /* shift + tab */ {
                lastElement.focus();
                e.preventDefault();

            } else if (!e.shiftKey && (document.activeElement === lastElement)) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    },

    /**
     * Scrolls page to top
     */
    scrollToTop: function() {
    	$('#headerskip').get(0).scrollIntoView(true);
        $('#headerskip').focus();
    },
    
    /**
     * Focuses on an element without scrolling to it
     */
    focusWithoutScroll: function(elem) {
    	let x = window.scrollX;
    	let y = window.scrollY;
    	elem.focus();
    	window.scrollTo(x, y);
    },
    
    /**
     * Sets lisener on first and last
     * element on modal, and traps focus inside them
     */
    bindModalFocusEvents: function(firstElement, lastElement){
		$(firstElement).unbind('keydown').bind('keydown', function(e) {COSTCO.util.setElementFocus(firstElement, lastElement, e)});
        $(lastElement).unbind('keydown').bind('keydown', function(e) {COSTCO.util.setElementFocus(firstElement, lastElement, e)});
    },
    trapFocusInsideModal : function (){
        let modalBody = $(".modal-dialog").get(0);
        if (modalBody != undefined) {
            let focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
            let focusableVisible = COSTCO.util.returnAllFocusableVisibleElements(focusableElements);
            if (focusableVisible.length > 0) {
                let firstElement = focusableVisible[0];
                let lastElement = focusableVisible[focusableVisible.length - 1];
                COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
            }
        }
    },
    /**
     * Showes and hides elemenet based on flag parameter
     * @param element
     * @param flag
     */
    showHtmlElementByFlag : function(element, flag) {
        if (element == undefined || flag == undefined) {
            return false;
        }
        if (flag === true) {
            element.removeClass('hide');
        } else {
            element.addClass('hide');
        }
    },
    /**
     * Test if this page is part of new design.
     * @return true if page is part of new design, false otherwise
     */
    isPDPCartCheckoutEnabled : function() {
    	return costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || 
    			costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE ||
          costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE;
    },

    /**
     * Method to convert the date input string to Timestamp format
     */
    convertDateToTimestamp: function (dateSring) {
    	var dateTimeParts = dateSring,
    	dateParts = dateTimeParts.split('-'),date; 
    	date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], '00', '00');
    	return date.getTime()
    },
    globalErrorElementClasses: ['critical-notification', 'error', 'lists-error', 'form-error-text'],
    base64test: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/,
    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    _keyStrExcl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    getUrlToLangMap: function(){
    	let urlToLanguageMap = sessionStorage.getItem("urlToLanguageMap");
    	if(urlToLanguageMap == null){
    		return JSON.parse("{}");
    	}
    	else{
    		return JSON.parse(urlToLanguageMap);
    	}
    },
    addUrlToLangMap: function(url, selectedLang){
    	let urlToLanguageMap = COSTCO.util.getUrlToLangMap();
    	// Checked with business and we will accommodate 50 items in history to 
    	// check for language to reasonably meet most of customers' activities.
    	if(Object.keys(urlToLanguageMap).length >= 50){
    		var keyToDelete = Object.keys(urlToLanguageMap)[0];
    		delete urlToLanguageMap[keyToDelete];
    	}
    	urlToLanguageMap[url] = selectedLang;
    	sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
    },
    removeUrlFromLangMap: function(url){
    	let urlToLanguageMap = COSTCO.util.getUrlToLangMap();
    	delete urlToLanguageMap[url];
    	sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
    },
    /**
     * 1. Create a map of url pathname and the language at the time the url was accessed 
     * 2. During browser history back and forward, if the selectedLanguage and value of the language from the map
     * 		do not match, then do a hard load of the page
     */
    registerLanguageListener: function(){
        // Register event if event function is not already defined
        if(typeof window.onpageshow !== "function"){
      	  window.onpageshow = function(event) {
      		  var currentLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
    		  var currentUrl = window.location.pathname;
      		  // event.persisted is faulty, so use window.performance.navigation.type also
      		  if (event.persisted || (window.performance && 
      		            window.performance.navigation.type == 2)) {
      			  // window.performance.navigation.type = 2 means back or forward
          		  var langSettingForCurrentUrl = COSTCO.util.getUrlToLangMap()[currentUrl];
                  if (langSettingForCurrentUrl !== undefined && langSettingForCurrentUrl !== currentLang) {
                    console.log("Doing hard reload since language has changed");
                    COSTCO.util.removeUrlFromLangMap(currentUrl);
                    if (isMobileApp == 'true') {
                      COSTCO.myLocation.reloadWithNewLanguage(currentLang);
                    }
                  }
                }
      		  else{
      			COSTCO.util.addUrlToLangMap(currentUrl, currentLang);
      		  }
      	  }
        }
    },
    /*
     * A11Y STRY0166460
     */
    closeDropdownWhenOutOfFocus: function(){
    	$('.list-group-item').find('a').focusin(function(){
    		if(!$(this).parents('.dropdown-container').hasClass('open')){
    			$('.dropdown-container.open').removeClass('open');
    		}
    	});
    	$('#search-field').focusin(function(){
    		$('.dropdown-container.open').removeClass('open');
    	});
    },

    /* A screen reader user should only be able to access one search field 
     * ADA STRY0166458
     */
    
    addAriaHiddenToHiddenInput: function(){
      	 $("input[type=text].tt-hint").attr("aria-hidden", "true");
       },

    
    /** DSR Membership Enquiry - used to open Membership inquiry modal
     * 
    */
	membershipDetailedEnquiry : function() {
    	let modalOptions = {
    	        title: messages.RWD_MEMBERSHIP_NUMBER,
    	        body: COSTCO.util.tmpl('tmpl_membership_modal'),
    	        primary: messages.CLOSE,
    	        primary_button_fullspan:false,
        		primary_event: function() {
        			COSTCO.dialog.close();
        		}
    	      }
    	COSTCO.dialog.showAndHideModal(modalOptions);
	},
	/**
     * Method return timeout function for fetch method to call API services
     */
    getTimeoutController:function(){
  	  /**
	      * Timeout function
	      * @param {Integer} time (miliseconds)
	      * @param {Promise} promise
	      */
	      const timeout = (time, promise) => {
	        return new Promise(function(resolve, reject) {
	          setTimeout(() => {
	            reject(new Error('API_TIMEOUT'))
	          }, time);
	          promise.then(resolve, reject);
	        });
	      }
	      return timeout;
    },
	/**
     * Method to check if a DOM element is present using its ID and verify the value of the element
     * return true if the value matches, else false.
     */
    checkElementById :function(elementId, value){
    	var elementValueMatch = false;
    	if($(elementId).length > 0 && $(elementId).val() === value){
    		elementValueMatch = true;
    	}
    	return elementValueMatch;
    },
    
    parseURL:function(url) {
        var a = document.createElement('a');
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(':',''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function(){
                var ret = {},
                seg = a.search.replace(/^\?/,'').split('&'),
                len = seg.length, i = 0, s;
                for (;i<len;i++) {
                    if (!seg[i]) { continue; }
                    s = seg[i].split('=');
                    ret[s[0]] = s[1];
                }
                return ret;
            })(),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
            hash: a.hash.replace('#',''),
            path: a.pathname.replace(/^([^\/])/,'/$1'),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
            segments: a.pathname.replace(/^\//,'').split('/')
        };
    },


    getParamVal:function(url, key){
    	var urlMap = COSTCO.util.parseURL(url);
    	return urlMap.params[key];

    },
    
    /**
     * Utility function detect is browser IE11 or older version
     * return boolean
     */
    isIE11OrOlder: function() {
    	let ua = window.navigator.userAgent;
    	let msie = ua.indexOf('MSIE ');
    	if (msie > 0) {
    	    // IE 10 or older 
    		return true;
    	}
    	let trident = ua.indexOf('Trident/');
    	if (trident > 0) {
    	    // IE 11 
    		return true;
    	}
    	return false;
    },
    
    
    /**
     * Utility function to check if user is logged in
     * return boolean
     */
    isUserLoggedIn: function(){
    	
    	try{
    		$.cookie("hashedUserId").length;
    		return true;
    	}catch(e){
    		return false;
    	}
    },
    
    objectExistsAndNonEmpty: function(obj) {
    	if (typeof obj == 'undefined') {
    		return false;
    	} else if (obj == null) {
    		return false;
    	} else if (obj == '') {
    		return false;
    	} else {
    		return true;
    	}
    },
    filterItems: function(arr, query){
    	return arr.filter(function(el) {
    	      return el.toLowerCase() != query.toLowerCase()
    	 });    	
    },
	  

signoutNextAuth : function() {
  // Fetch CSRF token
  fetch("/api/auth/csrf", {
    method: "GET",
    headers: {
      "Accept": "*/*",
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "Pragma": "no-cache",
      "Sec-Fetch-Mode": "cors",
      "Sec-Fetch-Site": "same-origin",
      "Credentials": "include"
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }
    return response.json();
  })
  .then(data => {
    const csrfToken = data.csrfToken;
    
    // Sign out using CSRF token
    return fetch("/api/auth/signout", {
      method: "POST",
      headers: {
        "Accept": "*/*",
        "Cache-Control": "no-cache",
        "Content-Type": "application/x-www-form-urlencoded",
        "Pragma": "no-cache",
        "Sec-Fetch-Mode": "cors",
        "Sec-Fetch-Site": "same-origin",
        "Credentials": "include"
      },
      body: new URLSearchParams({
        csrfToken: csrfToken,
        callbackUrl: new URL(window.location.href).origin + "/?ao=yes",
        json: true
      })
    });
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to sign out');
    }
    return response.json();
  })
  .then(data => {
    console.log(data.message);
    // Handle success message as needed
  })
  .catch(error => {
    console.error('Error signing out:', error);
    // Provide user feedback here if needed
  });
},
    logoutSso: function(obj, logOffUrls, isSsoEnabled, isMobileApp){
    	  sessionStorage.removeItem("SelectedPatientIndex");
  		  $.cookie('PrescriptionCount', null, {path:'/'});
    	try{  
    		console.log("Sign out ");
			if (typeof Android != 'undefined') {
				console.log("Android sign out ");
				Android.onSignOut();
			} else if (typeof webkit != 'undefined') {
				console.log("Webkit sign out ");
 				webkit.messageHandlers.onSignOut.postMessage('');
    		}
			console.log("Sign out finished");
    		if(isSsoEnabled == '0' || isSsoEnabled == null || isSsoEnabled == '' || isSsoEnabled == false || isMobileApp == null || isMobileApp == '' || isMobileApp == 'true'){
    			window.location = window.location.origin+"/Logoff?usrClk=true";
    			return;
    		}
    		
    		var logOffAcion = "/security/v1/users/session/ssologoff";
		
		//New home page support.
		try{
		    COSTCO.util.signoutNextAuth();
		}catch(k){}
    		
    		$.cookie('C_GOP', null, {path:'/'}); 
    		if((logOffUrls == null) || (logOffUrls == undefined) || (logOffUrls == "")){
    			window.location = window.location.origin+"/Logoff?usrClk=true";
    			return;
    		}
    		
    		logOffUrls = logOffUrls.split(",");  
    		logOffUrls = COSTCO.util.filterItems(logOffUrls , window.location.origin);
    		
    		if(logOffUrls != null && logOffUrls.length > 0){
    		   	var targetUri ='';    			
	
    		   	if(costcoStoreFeatures.OCUCO_LOGOUT_ENABLED === true){
    		   		targetUri = logOffUrls[0]+logOffAcion + '?' + 'a='+logOffUrls[1]+logOffAcion + '&b='+logOffUrls[2]+logOffAcion+'&c='+logOffUrls[3]+ "/Account/Logout";
    			} else {
     			targetUri = logOffUrls[0]+logOffAcion + '?' + 'a='+logOffUrls[1]+logOffAcion + '&b='+logOffUrls[2]+logOffAcion;  
    			}
        		var logoffWindow = window.open(targetUri, '_blank');    		
        		setTimeout(function() {
       			logoffWindow.close();
                window.location = window.location.origin+"/Logoff?usrClk=true";                			    			
        		}, 3800); //milliseconds
    		
    		}else{
    			window.location = window.location.origin+"/Logoff?usrClk=true";
    		}
    	}catch(e){
    		console.log(e);
    		window.location = window.location.origin+"/Logoff?usrClk=true";
    	}
    	
    },

    /**
		 * This function strips anything that isn't a number
     * Intended for quantity selector 
		 * @param {[string] inputValue}  
		 * @returns {[number] outputValue}
		 */
    stripStringOfNonNumberTypes: function(inputValue){
      let outputValue = inputValue.replace(/[^\d]/g, "");
      return outputValue;
    },
    /**
     * Checks if the current context is related to a locationControlledInventory product. 
     */
    islocationControlledInventoryFlow: function() {
      	var islocationControlledInventoryFlow = $('#regionalIdentifier').length>0 && $('#regionalIdentifier').val()=='true'?true:false;   	
      	return islocationControlledInventoryFlow;
     }
    ,

    /**
     * Checks if the current context is related to a siteControlledInventory product. 
     */
    issiteControlledInventoryFlow: function() {
      var issiteControlledInventoryFlow = $('#regionalIdentifier').length>0 && $('#regionalIdentifier').val()=='false'?true:false;   	
      return issiteControlledInventoryFlow;
   },
    
    getFiveDigitPostalCode : function(postalCode){
	    var zipCode = postalCode;
	    var finalZip ='';
	    var zipCodeWithoutExtraFour = zipCode.split('-');
      if (zipCodeWithoutExtraFour.length > 1) {
        finalZip = zipCodeWithoutExtraFour[0];
      } else {
        finalZip = zipCode;
      }
      return finalZip;
    },
	    
	  formatPhoneNumber: function(number) {
		  var phNumber = number.replace(/\D/g,'');
	    return phNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    
    },
	    
    cancelMemberApplication: function(partNumber) {
      let appTrackingCookie = $.cookie('APPLICATION_TRACKING_COOKIE');
      let currentPage = window.location.pathname.substr(1);

      if(document.referrer === "") {
        window.location.href = '/CheckoutCartView';
      } else {
        
        if(appTrackingCookie !== 'null' || 'undefined') {
          if($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1){
            path = `/MembershipApplicationView?productPartNumber=${partNumber}&fromPage=${currentPage}`;
          } else {
            path = `/QuickMembershipApplicationView?productPartNumber=${partNumber}&fromPage=${currentPage}`;
          }
          console.log('path: ', path);
          window.location.href = path;
          return;
        }
        window.location.href = COSTCO.util.scrubSpecialChars(document.referrer);
      }
    },
  
    /** selects the input radio buttons inside the given element
		 * used for all the radio buttons/selection-boxes combined elements */
     selectRadioBox: function(element) {
			$(element).find('input').prop('checked', true);
    },
    
    /** used on onblur event of all fields so that the screen reader 
		 * would announce the error when focus moves out of the field */
		alertScreenReader: function(element) {
			if ($(element).attr('aria-invalid') === 'true') {
				let elementName = $(element).attr('name');
				let errorElement = $('#' + elementName + 'Error');

				errorElement.removeAttr('role');
				errorElement.attr('role', 'alert');
			}
		},
    
    ariaSetElementAsValid: function(element) {
      if (element) {
        element.removeAttr('aria-describedby');
        element.attr('aria-invalid', 'false');
      }
    },

    ariaSetElementAsInvalid: function(element, describedByElementId) {
      if (element) {
        element.attr('aria-describedby', describedByElementId);
			  element.attr('aria-invalid', 'true');
      }
    },
    /**
     * Gets element with back to top link and (if exists) binds keydown and click event
     * that moves focus to top of the page. For Gatsby enabled pages # routing is implemented
     * so we have add event to div rather than adding a new hash to current url
     *
     * @param backToTopLink
     */
    setEventOnBackToTopLinkGatsby: function(backToTopLinkClass){
    	 /* ADA to move focus on skip link click */
    	 let $backToTopLink = ($(backToTopLinkClass).find("a").length > 0) ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
    	 //Added for gatsby body focus
    	  $backToTopLink.click(function() {
    	      $backToTopLink.attr("href", window.location.href);
    	      COSTCO.util.scrollToTopGatsby();
    	            });
    	   $backToTopLink.keydown(function(e) {
    	       $backToTopLink.attr("href", window.location.href);
    	       if(e.keyCode === 13)
    	          COSTCO.util.scrollToTopGatsby();
    	             }
    	        );
    	  },
      
       /**
     * This function opens and closes accordion that contains drugs list
     * @param  {String} letter capital letter of drugs
     * @param  {String} html element that was clicked
     * @param  {String} hostProtocolURL 
     * @return {void}
     */
      show_drug_list_by_capital_letter: function(letter, hostProtocolURL, element) {
        if($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in') && $('#cmpp-drugs-by-letter-accordion-collapse').attr('data-letter') == letter) {
                        $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
                        $(element).children(".cmpp-close").addClass("hidden");
                        $(element).removeClass("cmpp-title-active");
                        $('html, body').animate({scrollTop: $(element).offset().top}, 800);
                } else{
 
                        if($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in')) {
 
                                $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
 
                                setTimeout(function(){
                                                COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
                                }, 700);
                        } else {
                                COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
                        }
                }
     },
     /**
      * This function handles building the drug list that corresponds
      * with first letter of drug name.
      * @param  {String} stateCode used to filter list of all cmpps
      * @param  {String} html element that was clicked
      * @param  {String} hostProtocolURL
      * @return {void}
      */
     drug_list_by_capital: function(letter, hostProtocolURL, element) {
 
                $('#cmpp-drugs-by-letter-accordion-collapse').remove();
                $('html, body').animate({scrollTop: $(element).offset().top}, 800);
 
                $(".panel-group div div div").removeClass("cmpp-title-active");
                $(".panel-group div div .cmpp-close").addClass("hidden");
                $(element).addClass("cmpp-title-active");
                $(element).children(".cmpp-close").removeClass("hidden");
 
                $(element).parent().after(COSTCO.util.tmpl('tmpl_drugs_by_letter', {
                letter: letter
        }));
                let windowWidth = $(window).width();
                let colNum = 1;
                if (windowWidth > 1025){
                        colNum = 3;
                } else if (windowWidth > 667) {
                        colNum = 2;
                };
                let drugNamesObj = JSON.parse(allDrugNamesMap[0].jsonDrugNameURL);
                let drugArr = [];
                for (const el in drugNamesObj) {
                  if (el.substring(0,1) === letter) {
                        let obj = {
                                drugName: el,
                                drugUrl: drugNamesObj[el]
                        }
                        drugArr.push(obj);
                  }
                }
                const numOfItems = drugArr.length;;
                const numOfRows = Math.ceil(numOfItems/colNum);
                for (var i = 0; i < numOfRows; i++) {
                  $('#cmpp-drugs-by-letter-accordion-collapse-panel').append(COSTCO.util.tmpl('tmpl_drugs_list_by_capital_letter', {
                          drugLink1: drugArr[i] && hostProtocolURL+drugArr[i].drugUrl,
                          drugLink2: drugArr[i + numOfRows] && hostProtocolURL+drugArr[i + numOfRows].drugUrl,
                          drugLink3: drugArr[i + 2*numOfRows] && hostProtocolURL+drugArr[i + 2*numOfRows].drugUrl,
                          drugName1: drugArr[i].drugName && drugArr[i].drugName,
                          drugName2: drugArr[i+ numOfRows] && drugArr[i+ numOfRows].drugName,
                          drugName3: drugArr[i+ 2*numOfRows] && drugArr[i+ 2*numOfRows].drugName,
                          numOfCol: colNum,
   
                  }));
                }
                $('#cmpp-drugs-by-letter-accordion-collapse').collapse('show');
        },
    /**
     * Scrolls page to top
    */
     scrollToTopGatsby: function() {
    	 document.getElementById("gatsbyIndex").scrollIntoView(true);
    	 document.getElementById("gatsbyIndex").focus();
     },

    /**
      * Util to give an interactive character count down
      * @param  {ojbect} label    pass the jquery obj where you want the
      *                           countdown to reflect
      * @param  {object} textarea pass a 'text' input
      *                           (input[type='text'],textarea) to count
      * @return {void}
	  */
    character_count: function character_count(label, textarea) {
      if ($(label).length > 0 && $(textarea).length > 0) {
        let updateLabelCount = function updateLabelCount(textarea, label) {
          let count = $(textarea).val().length;
          $(label).text(max - count);
        };

        let max = parseInt($(textarea).attr('maxlength'));
        $(label).text(max - $(textarea).val().length);
        $(textarea).unbind('keyup').on('keyup', function () {
          updateLabelCount(this, label);
        });
        $(textarea).unbind('change').on('change', function () {
          updateLabelCount(this, label);
        });
      }
    },
    getCookieByName: function(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
     
    // function for sanitizing data to prevent XSS attacks
    replaceSpecialChars: function(obj)
    {
      var result = new String(obj);

      result = result.replace(/&/g, "&amp;");
      result = result.replace(/</g, "&lt;");
      result = result.replace(/>/g, "&gt;");
      result = result.replace(/'/g, "&#39;");
      result = result.replace(/"/g, "&quot;");
      result = result.replace(/\//g, "&#47;");
      result = result.replace(/\\/g, "&#92;"); 

      return result;
    },
    /**
     * Async SHA256 encryption
     * @param {} message text that will be hashed
     * @param {} callback 
     */
    sha256: function (message, callback) {
      const encoder = new TextEncoder();
      const data = encoder.encode(message);
      crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      callback(hashHex);
      }).catch(error => {
      console.error('Error calculating SHA-256 hash: ', error);
      callback(null);
      });
   },
    getCookieStartingWith: function(prefix) {
      const cookies = document.cookie.split(';');
      
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
    
        // Check if the cookie starts with the specified prefix
        if (cookie.startsWith(prefix)) {
          // Extract the value of the cookie
          return cookie.substring(prefix.length + 1);
        }
      }
    
      // Return null if no matching cookie is found
      return null;
    },
    
    /**
     * Decode JWT and check for validity.  
     * */
    checkJWTExpiry: function (JWT) {
 	   let expired = true;
 	   let JWT_payload = JSON.parse(atob(JWT.split('.')[1]));
 	   if (typeof JWT_payload != 'undefined' && JWT_payload != null) {
 		   let currentTimeInMiliseconds = Date.now();
 		   let validUntil = Number(JWT_payload.created_at) + Number(JWT_payload.expires_in) - 3600000;
 		   if (currentTimeInMiliseconds < validUntil) {
 			   expired = false;
 		   }
 	   }
 	  return expired;
    },
    sentenceToPascalCase: function(sentence) {
    	  return sentence
    	    .split(' ')
    	    .map(function(word) {
    	      // Keeps only letters and numbers (including accented/Unicode letters)
    	      return (word.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g) || []).join('');
    	    })
    	    .map(function(word) {
    	      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    	    })
    	    .join(' ');
    },
    isElementEmpty: function (elementValue) {
    	if (typeof elementValue === 'undefined' || elementValue === null || elementValue === '' ) return true;
    	return false;
    }
  };  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.util = util;

  return util;
});



// WEBPACK FOOTER //
// ./js/global/utility1.js